var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgA1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 172.62 303.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-4 {\n        fill: #6f5b2c;\n      }\n\n      .cls-5 {\n        fill: #615028;\n      }\n\n      .cls-6 {\n        fill: #b18f39;\n      }\n\n      .cls-7 {\n        fill: #77612f;\n      }\n\n      .cls-8 {\n        fill: #b59239;\n      }\n\n      .cls-2 {\n        stroke: #010201;\n        stroke-miterlimit: 122.43;\n        stroke-width: .36px;\n      }\n\n      .cls-9, .cls-10 {\n        fill: #fff;\n      }\n\n      .cls-9, .cls-3 {\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3.01px;\n      }\n\n      .cls-11 {\n        fill: #9e8037;\n      }\n\n      .cls-12 {\n        fill: #967b36;\n      }\n\n      .cls-13 {\n        fill: #a38538;\n      }\n\n      .cls-14 {\n        fill: #7f6731;\n      }\n\n      .cls-15 {\n        fill: #8f7535;\n      }\n\n      .cls-16 {\n        fill: #957a36;\n      }\n\n      .cls-17 {\n        fill: #c92329;\n      }\n\n      .cls-18 {\n        fill: #574824;\n      }\n\n      .cls-19 {\n        fill: #9a7e37;\n      }\n\n      .cls-20 {\n        fill: #67552a;\n      }\n\n      .cls-21 {\n        fill: #5b4b25;\n      }\n\n      .cls-22 {\n        fill: #af8d39;\n      }\n\n      .cls-23 {\n        fill: #846d33;\n      }\n\n      .cls-24 {\n        fill: #866e33;\n      }\n\n      .cls-25 {\n        fill: #a58638;\n      }\n\n      .cls-26 {\n        fill: #b79439;\n      }\n\n      .cls-27 {\n        fill: #010201;\n      }\n\n      .cls-28 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-29 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-30 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-31 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-32 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-33 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-34 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-35 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-36 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-37 {\n        fill: #5e4d26;\n      }\n\n      .cls-38 {\n        fill: #8c7234;\n      }\n\n      .cls-39 {\n        fill: #755f2e;\n      }\n\n      .cls-40 {\n        fill: #a88838;\n      }\n\n      .cls-41 {\n        fill: #816a32;\n      }\n\n      .cls-42 {\n        fill: #b89439;\n      }\n\n      .cls-43 {\n        fill: #a08238;\n      }\n\n      .cls-44 {\n        fill: #927735;\n      }\n\n      .cls-45 {\n        fill: #69562a;\n      }\n\n      .cls-46 {\n        fill: #7d6631;\n      }\n\n      .cls-47 {\n        fill: #715d2e;\n      }\n\n      .cls-48 {\n        fill: #313e8c;\n      }\n\n      .cls-49 {\n        fill: #78622f;\n      }\n\n      .cls-50 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-51 {\n        fill: #7a6330;\n      }\n\n      .cls-52 {\n        fill: #6c592c;\n      }\n\n      .cls-53 {\n        fill: #897034;\n      }\n\n      .cls-54 {\n        fill: #ac8b39;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159.51,216.05s.07-.08.1-.11c-.03.04-.07.08-.1.11M158.73,216.79s-.01.05-.01.11c.24-.26.53-.59.78-.85-.31.32-.56.54-.77.74Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.89,216.9c.01-.05,0-.1-.01-.11-.44-.39-.67-.65-.88-.86l.89.97h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.58,290.2c.31.3.72.68,1.03.98-.41-.39-.61-.62-.9-.96-.02-.02-.04-.02-.09-.02h-.04Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.58,223.62c.06,0,.11,0,.13-.02.42-.5.67-.74.9-.96l-1.03.98h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.92,223.6s.05.02.12.02c-.31-.3-.72-.68-1.03-.98.41.39.61.63.91.96Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7,290.2s-.07,0-.08.02c-.43.5-.68.74-.91.96l1.03-.98h-.04Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.01,291.18l-3,2.85c2.1.11,3.44.7,4.95,2.17,1.46,1.43,2.07,2.7,2.26,4.75q3.14-3.44,3.66-3.92c-.13.11-1.13-1.8-3.1-3.71-1.99-1.96-3.99-2.95-3.86-3.09-.43.5-.69.75-.91.96h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.84,293.31c-1.96,1.91-2.98,3.83-3.07,3.74.37.33.53.49.84.82l2.78,3.07c.19-2.04.8-3.32,2.26-4.75,1.52-1.47,2.84-2.06,4.95-2.17q-3.41-3.24-3.9-3.81c.11.15-1.88,1.13-3.87,3.09h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.73,216.79c.13-.11,1.14,1.79,3.1,3.7,1.98,1.97,3.98,2.96,3.87,3.1.42-.5.67-.73.9-.96l3-2.85c-2.11-.1-3.44-.7-4.95-2.16-1.46-1.45-2.07-2.71-2.26-4.76q-3.13,3.44-3.66,3.93h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.96,217.63c-1.51,1.47-2.85,2.06-4.95,2.16q3.41,3.24,3.91,3.81c-.13-.14,1.87-1.13,3.86-3.1,1.97-1.91,2.97-3.81,3.07-3.74-.37-.33-.51-.48-.84-.82l-2.79-3.07c-.19,2.05-.79,3.31-2.26,4.76Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12835"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12837",
    className: "cls-10",
    d: "M51.27,118.27l-3.18-26.97-2.85,26.97h6.02ZM157.7,199.13c-.82,0-1.65-.15-2.47-.43-.58-.25-1.07-.62-1.52-1.03-.27.23-.62.34-.99.34h-41.13c-.59,0-1.12-.34-1.36-.88l-3.32-7.28c-.19,1.58-.63,3.14-1.42,4.47-1.92,3.08-4.33,4.69-6.96,4.69-.56,0-1.13-.07-1.7-.22-.95-.05-1.83-.51-2.63-1.12-.26.21-.6.33-.95.33h-36.81c-.57,0-1.11-.33-1.35-.84l-4.47-9.26c-.1-.2-.15-.43-.15-.66v-18.5c0-.84.68-1.51,1.51-1.51h5.14l-1.61-14.65h-14.29l-1.74,14.65h1.46c.61,0,1.16.37,1.39.93l6.47,15.84c.07.18.11.37.11.57v11.94c0,.83-.67,1.5-1.51,1.5H14.04c-.59,0-1.12-.34-1.37-.87l-4.27-9.25c-.09-.2-.14-.41-.14-.63v-18.52c0-.84.67-1.51,1.51-1.51h5.4L30.98,39.22h-1.65c-.57,0-1.08-.31-1.34-.82l-4.24-8.22c-.11-.21-.17-.44-.17-.68V10.38c0-.83.68-1.5,1.51-1.5h46.01c.62,0,1.17.37,1.4.95l6.33,15.89c.07.18.11.37.11.56v11.44c0,.83-.68,1.5-1.51,1.5h-5.08l15.13,128.1c.41.14.75.47.91.89l.65,1.75c1.63-1.57,3.59-2.43,5.62-2.43.74,0,1.47.11,2.2.34,4.45,1.63,6.11,6.32,7.71,10.87.39,1.12.78,2.19,1.18,3.19v-13.19c0-.84.67-1.51,1.51-1.51h5.08V43.86h-3.49c-.58,0-1.11-.33-1.35-.85l-4.33-8.94c-.1-.2-.15-.43-.15-.66v-16.91c0-.6.36-1.15.92-1.39l31.44-13.27c.19-.08.38-.12.59-.12.47,0,.93.22,1.22.63l.27.38,6.55,14.34c.09.19.13.41.13.62v149.53h2.24c.66,0,1.24.43,1.43,1.06.16.51.38,1.19.61,1.86,1.65-1.68,3.67-2.6,5.78-2.6.95,0,1.89.19,2.8.55,3.9,1.92,5.47,6.1,7.01,10.15.57,1.52,1.12,2.95,1.76,4.22,1.53,3.81.81,8.68-.67,11.58-1.89,3.3-4.49,5.07-7.38,5.07"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12839"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12841",
    className: "cls-10",
    d: "M42.54,154.08h11.61l1.29,11.64h-3.46c-1.66,0-3.01,1.35-3.01,3.01v11.73l-5.25-12.87c-.43-1.06-1.42-1.77-2.56-1.86l1.38-11.65ZM46.91,116.77l1.26-11.92,1.41,11.92h-2.67ZM135.94.22c-.39,0-.78.08-1.17.24l-31.44,13.27c-1.12.47-1.84,1.56-1.84,2.77v16.91c0,.45.1.9.3,1.31l4.33,8.93c.5,1.04,1.55,1.7,2.7,1.7h2v120.37h-3.58c-1.66,0-3.01,1.35-3.01,3.01v4.99c-1.42-3.15-3.38-5.99-6.81-7.25-1-.32-1.89-.45-2.78-.45-1.73,0-3.42.52-4.93,1.49-.19-.44-.48-.81-.84-1.1l-14.84-125.69h3.38c1.66,0,3.01-1.35,3.01-3.01v-11.44c0-.38-.07-.76-.21-1.12l-6.33-15.89c-.45-1.14-1.56-1.89-2.79-1.89H25.09c-1.66,0-3.01,1.35-3.01,3.01v19.11c0,.48.11.95.33,1.38l4.24,8.22c.51.99,1.52,1.62,2.63,1.63l-15.44,125h-4.07c-1.66,0-3.01,1.35-3.01,3.01v18.52c0,.44.1.87.28,1.26l4.27,9.25c.49,1.07,1.56,1.75,2.73,1.75h33.35c1.66,0,3.01-1.35,3.01-3.01v-5.61l3.33,6.91c.5,1.03,1.56,1.7,2.72,1.7h36.8c.3,0,.57-.04.85-.12.76.44,1.62.79,2.61.91.6.14,1.22.21,1.82.21,3.14,0,6.07-1.91,8.22-5.38.19-.3.34-.61.5-.94l1.62,3.55c.49,1.07,1.55,1.76,2.73,1.76h41.13c.25,0,.5-.03.74-.09.33.24.68.45,1.07.62.07.03.13.05.2.08.99.34,1.99.52,2.97.52,3.45,0,6.52-2.05,8.66-5.77,1.65-3.24,2.56-8.54.84-12.84-.03-.08-.07-.16-.11-.24-.6-1.19-1.13-2.6-1.69-4.07-1.55-4.12-3.32-8.79-7.64-10.92-.07-.04-.14-.07-.22-.1-1.09-.43-2.22-.66-3.36-.66-1.79,0-3.5.54-5.04,1.55-.46-1.12-1.55-1.87-2.79-1.87h-.74V17.69c0-.43-.09-.85-.27-1.24l-6.39-14.08c-.08-.18-.18-.36-.3-.52l-.27-.38c-.58-.8-1.49-1.25-2.44-1.25M43.57,119.77h9.39l-4.94-42.02-4.45,42.02M71.09,10.38l6.33,15.89v11.44h-6.77l15.47,131.01h.85l1.57,4.2c1.51-2.36,3.7-3.91,6.11-3.91.57,0,1.16.09,1.75.27,5.24,1.93,6.14,9.77,8.74,14.94.68,3.01.53,6.83-.95,9.31-1.47,2.36-3.41,3.96-5.67,3.96-.43,0-.86-.05-1.31-.18-1.41-.1-2.53-1.17-3.65-2.18-.12.48-.32,1.36-.32,1.36h-36.8l-4.47-9.26v-18.51h6.82l-1.95-17.66h-16.98l-2.09,17.66h3.15l6.47,15.83v11.94H14.04l-4.27-9.25v-18.52h6.73L32.68,37.72h-3.36l-4.23-8.22V10.38h46M135.94,3.23l.28.38,6.39,14.08v151.04h3.74s1.01,3.27,1.65,4.4c1.6-2.65,3.85-4.07,6.18-4.07.74,0,1.49.15,2.24.44,4.56,2.25,5.61,8.98,7.98,13.65,1.24,3.12.73,7.48-.67,10.23-1.53,2.67-3.65,4.25-6.04,4.25-.64,0-1.3-.11-1.98-.35-1.01-.43-1.92-1.83-2.81-2.69-.03.43-.28,1.44-.19,1.93h-41.13l-4.34-9.53v-18.24h6.58V42.35h-5l-4.33-8.94v-16.91l31.44-13.27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12843"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12845",
    className: "cls-10",
    d: "M93.65,193.41c.31,0,.6.08.83.29l.38.35c.84.76,1.71,1.54,2.48,1.6.59.13.89.17,1.18.17,1.87,0,3.35-1.73,4.26-3.18,1.24-2.08,1.26-5.5.76-7.86-.72-1.47-1.32-3.15-1.9-4.78-1.43-4.05-2.85-8.03-5.81-9.12-.33-.1-.75-.17-1.16-.17-1.71,0-3.43,1.13-4.7,3.12l-.2.31c-.28.43-.76.68-1.26.68-.05,0-.11,0-.16,0-.56-.06-1.05-.43-1.25-.97l-1.29-3.46c-.67-.08-1.23-.61-1.31-1.3l-15.54-131.39c-.04-.43.09-.85.37-1.18.29-.32.7-.5,1.12-.5h5.29v-9.43l-5.79-14.53H26.78v17.02l3.58,6.94h2.53c.44,0,.85.19,1.13.51.29.33.42.76.36,1.19l-16.23,131.35c-.09.75-.73,1.32-1.49,1.32h-5.2v16.48l3.65,7.92h30.59v-9.91l-5.91-14.49h-2.22c-.43,0-.84-.19-1.13-.51-.28-.32-.42-.75-.36-1.17l2.11-18.01c.09-.76.74-1.33,1.49-1.33h17.31c.77,0,1.41.58,1.49,1.34l1.99,18.01c.04.43-.09.85-.38,1.17-.29.31-.69.5-1.12.5h-5.33v16.45l3.83,7.95h34.43s.02-.08.03-.11c.14-.51.56-1.05,1.06-1.19.21-.06.42-.09.64-.09M98.52,199.19c-.56,0-1.13-.07-1.72-.22-.94-.05-1.81-.5-2.58-1.07-.24.18-.52.29-.81.29h-37.07c-.57,0-1.09-.32-1.35-.84l-4.55-9.46c-.1-.2-.15-.43-.15-.65v-18.69c0-.83.67-1.51,1.51-1.51h5.11l-1.57-14.28h-13.98l-1.68,14.28h1.38c.62,0,1.18.38,1.4.95l6.5,16c.07.18.11.37.11.56v12.12c0,.84-.68,1.51-1.51,1.51H13.93c-.55,0-1.07-.31-1.32-.8l-4.37-9.51c-.09-.19-.14-.41-.14-.62v-18.71c0-.83.68-1.51,1.51-1.51h5.42l15.77-127.65h-1.57c-.57,0-1.09-.32-1.35-.84l-4.3-8.38c-.11-.21-.16-.45-.16-.69V10.2c0-.83.67-1.51,1.51-1.51h46.32c.64,0,1.2.4,1.41,1l6.37,16.02c.07.18.1.37.1.56v11.62c0,.83-.67,1.5-1.5,1.5h-5.06l15.09,127.74c.39.15.72.47.87.89l.6,1.62c1.64-1.48,3.57-2.3,5.55-2.3.73,0,1.48.11,2.23.34,4.53,1.66,6.28,6.59,7.82,10.93.62,1.79,1.23,3.47,1.93,4.86.05.1.1.22.12.33.7,3.03.78,7.39-1.12,10.59-2.47,3.95-5.24,4.78-7.13,4.78"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12847"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12849",
    className: "cls-10",
    d: "M42.7,154.26h11.29l1.24,11.28h-3.43c-1.66,0-3.01,1.35-3.01,3.01v11.04l-4.91-12.06c-.42-1.04-1.41-1.85-2.52-1.97l1.34-11.29ZM28.28,13.57h40.65l5.31,13.32v7.64h-3.79c-.85,0-1.68.37-2.25,1.01-.57.64-.83,1.5-.73,2.35l15.51,131.21s.02.18.02.19c.13,1.02.78,1.88,1.65,2.31l.91,2.44.13.36c.41,1.06,1.37,1.8,2.49,1.92.11.01.22.02.32.02,1.01,0,1.97-.51,2.52-1.37l.19-.31c.99-1.53,2.27-2.44,3.44-2.44.26,0,.52.04.78.13,2.17.8,3.45,4.43,4.7,7.95l.07.21c.57,1.61,1.17,3.27,1.89,4.77.47,2.4.21,5.2-.64,6.64-.43.68-1.65,2.41-2.95,2.41-.16,0-.34-.03-.55-.08-.17-.04-.34-.07-.51-.08-.31-.07-1.14-.83-1.59-1.23l-.37-.33c-.56-.51-1.29-.79-2.03-.79-.31,0-.61.05-.91.14-.73.24-1.33.73-1.7,1.37h-32.42l-3.27-6.8v-14.6h3.83c.85,0,1.67-.36,2.24-1,.57-.64.84-1.49.75-2.34l-1.97-17.85c-.17-1.52-1.47-2.84-3.01-2.84h-17.3c-1.52,0-2.81,1.14-2.98,2.66l-2.1,17.81-.02.19c-.1.85.16,1.71.73,2.35.57.65,1.39,1.01,2.25,1.01h1.2l5.42,13.28v8.12h-28.13l-3.11-6.75v-14.65h3.7c1.52,0,2.8-1.13,2.99-2.64L35.84,38.16c.04-.2.07-.41.07-.63,0-1.66-1.34-3.01-3.01-3.01h-1.64l-2.99-5.8v-15.16h0ZM71.21,7.19H24.9c-1.66,0-3.01,1.35-3.01,3.01v19.3c0,.48.11.95.33,1.37l4.27,8.31c.49.96,1.51,1.67,2.58,1.72l-15.4,124.64h-4.09c-1.66,0-3.01,1.35-3.01,3.01v18.71c0,.43.09.87.27,1.26l4.28,9.32s.05.1.08.16c.53.98,1.6,1.7,2.71,1.7h33.64c1.66,0,3.01-1.35,3.01-3.01v-5.04l2.99,6.24c.5,1.04,1.6,1.81,2.76,1.81h37.07c.24,0,.48-.03.7-.09.74.43,1.59.76,2.56.88.62.14,1.24.21,1.85.21,2.27,0,5.56-.95,8.38-5.46,2.16-3.64,2.1-8.44,1.33-11.75-.05-.24-.14-.46-.24-.67-.66-1.31-1.25-2.94-1.83-4.63-1.68-4.72-3.55-9.99-8.66-11.87-.05-.02-.11-.04-.18-.06-.89-.27-1.79-.41-2.67-.41-1.69,0-3.35.49-4.86,1.42-.19-.36-.44-.68-.74-.95l-14.82-125.41h3.37c1.66,0,3.01-1.35,3.01-3.01v-11.62c0-.38-.07-.76-.21-1.12l-6.35-15.95c-.46-1.14-1.6-2.01-2.84-2.01M32.89,37.53h.02M29.44,37.53h3.45l-.02.2-16.21,131.17h-6.7v18.31l4.19,9.1h33.06v-11.72l-6.4-15.7h-3.23l.02-.2,2.1-17.81h17.3l.02.16,1.97,17.85h-6.83v18.29l4.39,9.12h36.57c.05-.26.19-.86.29-1.22l.06-.29.38.35c1.03.93,2.1,1.9,3.38,2,.47.11.89.17,1.29.17,2.57,0,4.42-2.1,5.54-3.88,1.49-2.52,1.54-6.43.91-9.17-.76-1.48-1.37-3.26-1.99-4.98-1.48-4.18-3.01-8.49-6.64-9.82-.55-.17-1.12-.26-1.68-.26-2.24,0-4.41,1.39-5.97,3.81l-.19.31-.13-.33-1.52-4.09h-.87l-.02-.16-15.52-131.22h6.8v-11.22l-6.27-15.75H25.27v18.9l4.17,8.08M71.21,10.2l.04.12,6.35,15.96v11.62h-6.76l15.44,130.65h.8l.04.11,1.45,3.88c1.62-2.34,3.81-3.68,6.08-3.68.6,0,1.2.09,1.8.27,3.79,1.4,5.34,5.79,6.85,10.04.6,1.72,1.24,3.49,1.99,4.99.61,2.64.71,6.68-.95,9.48-1.65,2.65-3.67,4.05-5.83,4.05-.44,0-.9-.06-1.35-.17-1.34-.1-2.44-1.07-3.49-2.04-.11.48-.25,1.06-.25,1.06l-.02.14h-37.07l-.05-.1-4.48-9.33v-18.7h6.79l-1.9-17.3h-16.67l-2.04,17.3h3.08l.05.11,6.46,15.9v12.12H13.93l-.05-.1-4.28-9.32v-18.71h6.75L32.48,37.9h-3.26l-.05-.1-4.26-8.31V10.2h46.31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12851"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12853",
    className: "cls-10",
    d: "M51.06,118.09l-2.96-25.16-2.67,25.16h5.62ZM43.37,121.46c-.42,0-.82-.18-1.11-.49-.29-.31-.43-.73-.39-1.15l4.46-42.25c.08-.76.72-1.35,1.49-1.35h.36c.76,0,1.41.57,1.49,1.33l4.98,42.23c.04.43-.09.85-.37,1.18-.29.32-.7.5-1.12.5h-9.79Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12855"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12857",
    className: "cls-10",
    d: "M47.11,116.59l1.07-10.11,1.19,10.11h-2.26ZM48.19,74.72h-.36c-1.54,0-2.83,1.17-2.99,2.69l-4.43,42.02-.02.26c-.07.84.21,1.68.78,2.29.57.62,1.37.97,2.22.97h9.79c.85,0,1.68-.37,2.25-1.01.57-.64.83-1.49.73-2.35l-4.98-42.23c-.17-1.52-1.46-2.66-2.98-2.66M43.77,119.6h8.98l-4.73-40.22-4.25,40.22M48.19,77.73l4.98,42.23h-9.79l.02-.2,4.44-42.02h.36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12859"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12861",
    className: "cls-10",
    d: "M152.77,192.68c.39,0,.77.15,1.05.43l.27.27c.31.28.63.65.95,1.04.37.43.99,1.15,1.34,1.3.37.13.85.22,1.31.22,1.69,0,3.32-1.21,4.58-3.41,1.08-2.14,1.68-5.98.56-8.76-.64-1.24-1.2-2.73-1.83-4.4-1.32-3.48-2.68-7.05-5.32-8.36-.42-.16-.97-.27-1.51-.27-1.75,0-3.48,1.19-4.73,3.26-.28.45-.85.86-1.37.86h-.02c-.54-.01-1.11-.18-1.37-.64-.57-1.01-1.18-2.69-1.55-3.82h-2.7c-.83,0-1.51-.67-1.51-1.5V18.06l-5.74-12.67-28.98,12.24v15.41l3.68,7.64h4.15c.83,0,1.51.67,1.51,1.51v126.74c0,.83-.67,1.5-1.51,1.5h-5.09v16.2l3.74,8.21h38.51l.09-.77c.06-.57.44-1.07.98-1.27.17-.07.34-.09.52-.09M157.7,199.31c-.84,0-1.69-.15-2.55-.44-.55-.24-1.03-.58-1.46-.96-.23.18-.49.29-.77.29h-41.46c-.6,0-1.14-.36-1.39-.91l-4.39-9.69c-.09-.19-.13-.41-.13-.62v-18.42c0-.83.67-1.51,1.5-1.51h5.08V44.03h-3.44c-.58,0-1.11-.33-1.36-.85l-4.39-9.12c-.1-.2-.15-.43-.15-.65v-17.03c0-.6.36-1.15.91-1.39l31.68-13.37c.19-.08.39-.12.59-.12.46,0,.91.22,1.2.61l.37.49,6.58,14.46c.09.2.14.41.14.62v149.35h2.21c.63,0,1.2.4,1.41,1,.04.11.11.35.13.47,0,0,.2.59.45,1.32,1.65-1.59,3.64-2.46,5.69-2.46.98,0,1.95.2,2.89.57,3.95,1.93,5.62,6.34,7.08,10.22.61,1.6,1.14,3,1.76,4.23,1.62,4.04.78,8.89-.66,11.74-1.92,3.36-4.59,5.17-7.54,5.17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12863"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12865",
    className: "cls-10",
    d: "M107.69,18.61l26.72-11.28,5.01,11.04v150.53c0,1.66,1.35,3.01,3.01,3.01h1.63c.36,1.02.79,2.11,1.19,2.81l.13.23c.53.94,1.51,1.53,2.58,1.55h.05c1.06,0,2.03-.55,2.58-1.46l.16-.27c.97-1.61,2.23-2.53,3.44-2.53.31,0,.64.06.95.17,2.05,1.11,3.28,4.34,4.46,7.47.63,1.68,1.2,3.18,1.89,4.56.87,2.28.39,5.57-.58,7.48-.89,1.55-2.08,2.52-3.2,2.52-.24,0-.49-.03-.74-.11-.12-.13-.56-.64-.78-.89-.35-.41-.71-.82-1.07-1.16l-.24-.24c-.57-.56-1.33-.86-2.1-.86-.35,0-.7.06-1.03.19-.9.33-1.58,1.06-1.85,1.95h-36.25l-3.2-7.04v-14.37h3.59c1.66,0,3.01-1.35,3.01-3.01V42.17c0-1.66-1.35-3.01-3.01-3.01h-3.21l-3.12-6.48v-14.06ZM135.99,0c-.39,0-.78.08-1.17.24l-31.56,13.32c-1.11.47-1.95,1.61-1.95,2.82v17.03c0,.45.1.9.3,1.31l4.39,9.12c.5,1.05,1.55,1.71,2.71,1.71h1.94v120h-3.58c-1.66,0-3.01,1.35-3.01,3.01v18.42c0,.43.09.85.26,1.24l4.35,9.61c.49,1.08,1.6,1.87,2.79,1.87h41.46c.18,0,.36-.02.54-.05.3.21.63.4.98.55.07.03.14.06.21.09,1.01.35,2.04.53,3.04.53,3.52,0,6.65-2.08,8.81-5.86,1.66-3.27,2.58-8.63.85-12.99-.03-.08-.07-.16-.1-.24-.57-1.13-1.1-2.52-1.62-3.86l-.08-.22c-1.57-4.15-3.35-8.85-7.74-11-.06-.03-.13-.06-.19-.09-1.12-.45-2.28-.68-3.45-.68-1.74,0-3.43.51-4.94,1.47-.51-1.03-1.59-1.8-2.74-1.8h-.71V17.69c0-.43-.09-.85-.27-1.24l-6.42-14.19c-.09-.19-.19-.38-.32-.55l-.36-.49c-.58-.78-1.49-1.22-2.42-1.22M108.93,42.17h5.1v126.74h-6.59v18.02l4.28,9.39h40.81c0-.36.07-.84.14-1.24.03-.2.06-.39.07-.52l.04-.37.27.27c.28.27.56.6.85.94.61.71,1.24,1.43,1.89,1.71.64.22,1.29.34,1.91.34,2.25,0,4.35-1.48,5.89-4.16,1.3-2.55,1.95-6.84.65-10.07-.67-1.34-1.25-2.87-1.82-4.37-1.42-3.74-2.88-7.61-6.06-9.18-.71-.28-1.45-.43-2.18-.43-2.3,0-4.49,1.46-6.02,3.99l-.16.26-.15-.27c-.59-1.02-1.43-3.7-1.62-4.31h-3.81V17.73l-6.37-14.04-.18-.24-31.2,13.17v16.75l4.24,8.8M135.99,3.01l.37.49,6.42,14.2v150.85h3.72l.04.13s.85,2.81,1.48,4.1c1.59-2.48,3.82-3.9,6.16-3.9.78,0,1.56.15,2.32.47,3.33,1.63,4.82,5.57,6.26,9.37.56,1.48,1.14,3.02,1.82,4.36,1.32,3.34.67,7.75-.67,10.39-1.6,2.8-3.82,4.35-6.2,4.35-.66,0-1.36-.12-2.05-.36-.72-.31-1.37-1.07-2.01-1.81-.21-.24-.39-.45-.59-.66-.01.05-.02.11-.03.17-.08.44-.18,1.03-.12,1.34l.03.21h-41.46l-.04-.1-4.35-9.61v-18.42h6.59V42.53h-4.95l-4.39-9.12v-17.03l.11-.05,31.56-13.32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12867"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12869",
    className: "cls-10",
    d: "M53.66,120.84l-8.22-68.42-8.17,68.42h16.39ZM53.89,187.58c-.83,0-1.51-.67-1.51-1.51v-14.77c0-.83.67-1.51,1.51-1.51h5.7l-3.25-27.39h-21.6l-3.3,27.39h8.05c.83,0,1.51.67,1.51,1.51v14.77c0,.83-.68,1.51-1.51,1.51H11.68c-.83,0-1.5-.67-1.5-1.51v-14.77c0-.83.67-1.51,1.5-1.51h5.38L33.65,29.06h-6.66c-.83,0-1.51-.67-1.51-1.5v-14.6c0-.83.67-1.51,1.51-1.51h42.87c.83,0,1.51.67,1.51,1.51v14.6c0,.83-.67,1.5-1.51,1.5h-6.54l16.46,140.74h5.58c.83,0,1.5.67,1.51,1.51l.02,14.77c0,.39-.16.78-.44,1.06-.28.28-.67.44-1.07.44h-31.51ZM109.15,187.58c-.83,0-1.51-.67-1.51-1.51v-14.77c0-.83.68-1.51,1.51-1.51h5.1V33.69h-7.83c-.83,0-1.51-.67-1.51-1.5v-13.53c0-.6.36-1.14.91-1.39l28.66-12.34c.19-.08.39-.13.6-.13.29,0,.57.09.82.25.42.28.68.75.68,1.26v163.49h8.16c.83,0,1.51.67,1.51,1.51v14.77c0,.83-.67,1.51-1.51,1.51h-35.58ZM94.67,188.41c-4.07,0-7.37-4.22-7.37-9.39s3.31-9.39,7.37-9.39,7.37,4.22,7.37,9.39-3.31,9.39-7.37,9.39M154.05,188.41c-4.06,0-7.37-4.22-7.37-9.39s3.31-9.39,7.37-9.39,7.37,4.22,7.37,9.39-3.31,9.39-7.37,9.39"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12871"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12873",
    className: "cls-10",
    d: "M38.97,119.34l6.48-54.27,6.53,54.27h-13ZM69.87,9.95H26.99c-1.66,0-3.01,1.35-3.01,3.01v14.6c0,1.66,1.35,3.01,3.01,3.01h4.97L15.71,168.3h-4.03c-1.66,0-3.01,1.35-3.01,3.01v14.77c0,1.66,1.35,3.01,3.01,3.01h27.81c1.66,0,3.01-1.35,3.01-3.01v-14.77c0-1.66-1.35-3.01-3.01-3.01h-6.36l2.94-24.38h18.93l2.89,24.38h-4c-1.66,0-3.01,1.35-3.01,3.01v14.77c0,1.66,1.35,3.01,3.01,3.01h31.51c.8,0,1.57-.32,2.13-.88.41-.41.68-.93.81-1.47,1.6,1.98,3.83,3.19,6.33,3.19,4.97,0,8.87-4.79,8.87-10.89s-3.9-10.91-8.87-10.91c-2.48,0-4.69,1.19-6.29,3.14-.03-1.64-1.37-2.95-3.01-2.95h-4.25L65.03,30.57h4.85c1.66,0,3.01-1.35,3.01-3.01v-14.6c0-1.66-1.35-3.01-3.01-3.01M135.07,3.3c-.41,0-.81.08-1.19.25l-28.65,12.35c-1.1.48-1.81,1.56-1.81,2.76v13.53c0,1.66,1.34,3.01,3,3.01h6.33v133.1h-3.59c-1.66,0-3.01,1.35-3.01,3.01v14.77c0,1.66,1.35,3.01,3.01,3.01h35.58c1.46,0,2.67-1.03,2.95-2.41,1.6,2.01,3.85,3.24,6.37,3.24,4.97,0,8.87-4.79,8.87-10.89s-3.9-10.91-8.87-10.91c-2.5,0-4.71,1.2-6.31,3.17-.02-1.65-1.35-2.98-3.01-2.98h-6.66V6.31c0-1.02-.51-1.96-1.35-2.51-.5-.33-1.08-.5-1.65-.5M94.67,171.12c3.24,0,5.86,3.53,5.86,7.89s-2.62,7.88-5.86,7.88-5.87-3.53-5.87-7.88,2.62-7.89,5.87-7.89M154.05,171.12c3.24,0,5.86,3.53,5.86,7.89s-2.62,7.88-5.86,7.88-5.87-3.53-5.87-7.88,2.63-7.89,5.87-7.89M35.58,122.35h19.78l-9.93-82.58-9.85,82.58M69.87,12.96v14.6h-8.23l16.82,143.75h6.92l.02,14.77h-31.51v-14.77h7.39l-3.6-30.4h-24.26l-3.67,30.4h9.75v14.77H11.68v-14.77h6.71L35.35,27.56h-8.35v-14.6h42.88M135.07,6.31v165h9.67v14.77h-35.58v-14.77h6.6V32.19h-9.34v-13.53l28.66-12.34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12875"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12877",
    className: "cls-9",
    d: "M159.63,297.82l-.9-.81s-.01-.04-.01-.1l.89.96s.01-.02.02-.05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12879"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12881",
    className: "cls-10",
    d: "M159.61,299.38c-.39,0-.79-.15-1.09-.46l-.02-.03c-.18-.19-.39-.41-.78-.77-.34-.3-.53-.85-.5-1.3.03-.6.43-1.13,1-1.32.16-.06.33-.09.5-.09.41,0,.82.17,1.11.49l.89.96c.55.6.52,1.55-.08,2.11-.29.27-.66.41-1.03.41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12883"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12885",
    className: "cls-10",
    d: "M158.72,293.9c-.34,0-.68.05-1.01.18-1.14.41-1.92,1.45-2,2.66-.04.86.28,1.8.89,2.41.45.42.65.62.81.79.59.62,1.39.93,2.19.93.74,0,1.47-.26,2.05-.8,1.2-1.13,1.28-3.01.16-4.22l-.88-.96c-.59-.63-1.39-.97-2.22-.97M158.72,296.92l.89.96c-.21-.21-.44-.46-.88-.87-.02-.01-.02-.04-.01-.1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12887"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12889",
    className: "cls-9",
    d: "M159.61,215.94l-.89.97c0-.06,0-.1.01-.11l.9-.81s-.02-.04-.02-.05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12891"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12893",
    className: "cls-10",
    d: "M158.72,218.41c-.17,0-.34-.03-.51-.09-.56-.2-.95-.72-.99-1.32-.03-.5.2-1.1.61-1.41.11-.11.36-.33.68-.67.29-.32.7-.48,1.1-.48.37,0,.73.13,1.02.4.61.56.65,1.51.09,2.12l-.89.97c-.29.32-.69.48-1.1.48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12895"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12897",
    className: "cls-10",
    d: "M159.61,212.93c-.81,0-1.62.32-2.21.96-.28.3-.49.5-.68.67h0c-.68.63-1.06,1.62-1.01,2.53.08,1.2.87,2.24,1.99,2.65.33.12.67.18,1.01.18.82,0,1.63-.33,2.21-.96l.5-.55.39-.42c1.12-1.22,1.05-3.12-.16-4.25-.59-.53-1.32-.8-2.05-.8M159.61,215.94c-.27.29-.62.67-.89.96,0-.06,0-.1.01-.11.24-.22.51-.47.88-.85"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12899"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12901",
    className: "cls-9",
    d: "M12.99,215.99l.89.81s.01.03.01.07l-.89-.93s0,.02-.01.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12903"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12905",
    className: "cls-9",
    d: "M13,215.94l.89.93v.03l-.89-.96h0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12907"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12909",
    className: "cls-10",
    d: "M13.89,218.41c-.42,0-.82-.17-1.11-.49l-.88-.97c-.56-.61-.53-1.55.08-2.11.29-.27.66-.41,1.03-.41.39,0,.79.15,1.09.47.23.24.43.46.79.77.39.35.58.99.49,1.51-.1.56-.52,1.02-1.07,1.17-.14.04-.28.06-.42.06"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12911"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12913",
    className: "cls-10",
    d: "M13.01,212.98c-.73,0-1.46.26-2.04.8-1.2,1.12-1.31,2.97-.2,4.19l.89.97c.57.63,1.39.98,2.22.98.28,0,.56-.04.83-.12,1.1-.32,1.92-1.23,2.13-2.35.19-1.03-.19-2.18-.96-2.89-.31-.28-.49-.47-.65-.62-.6-.62-1.41-.95-2.22-.95M13,215.93c.2.21.43.47.88.86.02.01.02.05.01.11l-.89-.97"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12915"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12917",
    className: "cls-9",
    d: "M13,297.88l.89-.96c.01.06,0,.09-.01.1l-.89.81s.01.05.01.05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12919"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12921",
    className: "cls-9",
    d: "M12.99,297.83l.89-.81-.89.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12923"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12925",
    className: "cls-10",
    d: "M13,299.38c-.37,0-.75-.14-1.04-.42-.6-.57-.62-1.53-.05-2.13l.7-.74c.31-.34.8-.57,1.26-.57.12,0,.24.01.35.04.55.16,1.05.53,1.14,1.09.09.48-.08,1.08-.43,1.43-.26.25-.51.48-.85.84-.3.31-.69.46-1.08.46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12927"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12929",
    className: "cls-10",
    d: "M13.89,293.9c-.83,0-1.65.34-2.23.98l-.17.19c-.21.24-.46.51-.66.72-1.14,1.19-1.11,3.09.09,4.25.58.56,1.33.84,2.08.84.79,0,1.58-.31,2.17-.93.32-.33.54-.54.76-.74.75-.7,1.1-1.82.93-2.83-.2-1.13-1.02-2.05-2.12-2.37-.28-.08-.56-.11-.84-.11M13.89,296.92c.01.05,0,.09-.01.1-.25.23-.51.48-.88.87.27-.29.62-.68.89-.96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12931"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12933",
    className: "cls-9",
    d: "M166.6,291.18l-1.03-.98h.04l.98.98"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12935"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12937",
    className: "cls-9",
    d: "M166.59,291.18l-.98-.98s.07.01.08.02l.85.98s.04-.02.04-.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12939"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12941",
    className: "cls-9",
    d: "M166.55,291.19l-.85-.99h0s.83.99.83.99c.01,0,.02,0,.02,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12943"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12945",
    className: "cls-10",
    d: "M166.6,292.68c-.37,0-.75-.14-1.04-.42l-1.02-.97c-.44-.42-.59-1.05-.37-1.62.2-.56.73-.95,1.32-.98h.08c.51,0,1.1.27,1.39.69.18.19.36.39.69.71.6.57.62,1.53.05,2.12-.3.31-.7.47-1.09.47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12947"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12949",
    className: "cls-10",
    d: "M165.61,287.19c-.05,0-.14,0-.19,0-1.2.06-2.25.83-2.67,1.96-.42,1.13-.13,2.39.75,3.22l.38.36.64.61c.58.55,1.33.83,2.08.83.79,0,1.58-.31,2.17-.93,1.14-1.2,1.11-3.1-.09-4.25-.3-.28-.45-.47-.65-.7h0c-.58-.71-1.46-1.12-2.41-1.12M165.61,290.2s.08,0,.09.02c.3.34.5.57.9.96-.31-.3-.72-.67-1.03-.97h.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12951"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12953",
    className: "cls-9",
    d: "M166.54,222.61l-.83.99s-.06.03-.13.02l1.03-.98s-.03,0-.07-.03"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12955"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12957",
    className: "cls-10",
    d: "M165.46,225.12c-.59-.04-1.1-.44-1.3-1-.2-.56-.05-1.18.38-1.59l1.03-.98c.3-.28.67-.42,1.04-.42.4,0,.79.15,1.08.45.57.6.56,1.55-.03,2.12-.21.21-.44.44-.81.86-.28.33-.79.55-1.23.55-.04,0-.12,0-.16,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12959"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12961",
    className: "cls-10",
    d: "M166.59,219.63c-.74,0-1.48.27-2.06.83l-1.03.98c-.86.82-1.16,2.07-.76,3.19.39,1.12,1.42,1.9,2.6,1.99.08,0,.2.01.27.01.89,0,1.78-.41,2.37-1.08h0c.32-.37.53-.57.7-.74,1.18-1.16,1.23-3.06.07-4.25-.59-.62-1.38-.93-2.17-.93M166.6,222.63c-.22.22-.48.47-.9.96-.01.02-.04.02-.08.02h-.04l1.03-.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12963"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12965",
    className: "cls-9",
    d: "M6.01,222.64l1.03.98c-.07.01-.11,0-.13-.02l-.84-.99s-.07.03-.07.03"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12967"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12969",
    className: "cls-10",
    d: "M6.99,225.12c-.52,0-1.09-.3-1.36-.74-.12-.11-.31-.32-.67-.67-.6-.58-.61-1.53-.03-2.12.3-.31.68-.46,1.08-.46.37,0,.76.14,1.05.42l1.01.97c.43.41.59,1.03.38,1.59-.2.56-.71.95-1.3,1-.04,0-.12,0-.16,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12971"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12973",
    className: "cls-10",
    d: "M6.01,219.63c-.79,0-1.57.31-2.16.91-1.16,1.19-1.12,3.1.07,4.25.32.31.49.5.72.77h0c.58.66,1.47,1.06,2.35,1.06.08,0,.2,0,.27,0,1.18-.09,2.21-.87,2.61-1.99.39-1.12.09-2.38-.77-3.2l-1-.96c-.59-.56-1.34-.84-2.09-.84M6.01,222.64c.31.29.71.68,1.03.98h-.05s-.07,0-.08-.02c-.3-.33-.5-.57-.9-.96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12975"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12977",
    className: "cls-9",
    d: "M6.07,291.2l.84-.98s.06-.03.13-.02l-1.03.98s.02,0,.07.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12979"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12981",
    className: "cls-10",
    d: "M6.01,292.68c-.39,0-.79-.15-1.08-.46-.57-.6-.56-1.54.03-2.12l.03-.02c.2-.19.41-.4.79-.84.28-.33.78-.54,1.22-.54.62,0,1.19.37,1.42.95.22.57.1,1.22-.34,1.64l-1.02.98c-.29.28-.67.42-1.04.42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12983"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12985",
    className: "cls-10",
    d: "M7,287.19c-.89,0-1.78.41-2.37,1.07-.33.38-.51.56-.69.73-1.19,1.16-1.24,3.06-.09,4.25.59.62,1.38.93,2.17.93.74,0,1.48-.27,2.06-.83l1.03-.98c.87-.83,1.16-2.1.74-3.22-.42-1.13-1.47-1.9-2.67-1.96-.05,0-.14,0-.19,0M7,290.2h.04l-1.03.97c.22-.22.47-.45.9-.96,0-.01.04-.02.08-.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12987"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12989",
    className: "cls-10",
    d: "M13.89,218.41c-.42,0-.83-.18-1.11-.49l-3.67-4.02c-.4-.44-.5-1.08-.27-1.62.25-.55.78-.9,1.38-.9h152.18c.6,0,1.14.35,1.38.9.24.54.13,1.18-.27,1.62l-3.67,4.03c-.28.31-.7.49-1.12.49H13.89Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12991"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12993",
    className: "cls-10",
    d: "M162.4,209.87H10.22c-1.19,0-2.27.7-2.75,1.79-.48,1.09-.27,2.37.53,3.24l3.67,4.03c.57.62,1.37.98,2.22.98h144.84c.85,0,1.66-.36,2.22-.98l3.67-4.03c.8-.88,1.01-2.15.53-3.24-.48-1.09-1.56-1.8-2.75-1.8M162.4,212.88l-3.67,4.02H13.89l-3.67-4.02h152.18"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12995"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12997",
    className: "cls-10",
    d: "M13.86,298.53c-.83,0-1.22-.54-1.7-1.22-.48-.68-1.28-1.81-2.43-2.92-1.14-1.13-2.3-1.92-3.01-2.39-.71-.48-1.6-1.09-1.25-2.22.02-.06.04-.11.06-.18v-65.39c-.02-.06-.04-.11-.06-.18-.35-1.12.54-1.73,1.25-2.22.7-.48,1.86-1.27,2.99-2.39,1.16-1.13,1.97-2.26,2.44-2.92.49-.68.88-1.22,1.7-1.22.2,0,.39.04.58.11h143.73c.18-.08.38-.11.57-.11.83,0,1.23.55,1.72,1.23.48.67,1.28,1.8,2.42,2.9,1.14,1.13,2.3,1.92,3,2.4.72.49,1.61,1.1,1.26,2.22-.02.06-.04.11-.07.17v65.4c.02.05.04.11.07.17.35,1.12-.54,1.73-1.26,2.22-.7.48-1.86,1.26-2.99,2.39-1.14,1.11-1.95,2.23-2.43,2.91-.49.7-.88,1.24-1.71,1.24-.2,0-.4-.04-.58-.11H14.44c-.19.07-.38.11-.57.11h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13001",
    className: "cls-10",
    d: "M158.75,213.78c-.28,0-.56.04-.82.11H14.69c-.27-.08-.55-.11-.83-.11-1.6,0-2.4,1.11-2.92,1.85-.45.63-1.2,1.69-2.26,2.71-1.06,1.04-2.11,1.76-2.8,2.23-.76.51-2.53,1.72-1.85,3.91v64.85h0c-.68,2.19,1.09,3.39,1.85,3.91.7.48,1.74,1.19,2.78,2.21,1.07,1.04,1.82,2.1,2.27,2.73.52.74,1.32,1.86,2.92,1.86.28,0,.56-.04.83-.11h143.24c.26.08.54.11.82.11,1.62,0,2.41-1.13,2.95-1.87.45-.64,1.2-1.69,2.24-2.7,1.05-1.03,2.1-1.75,2.8-2.23.76-.51,2.52-1.72,1.85-3.9v-64.86c.67-2.18-1.09-3.39-1.85-3.9-.7-.47-1.74-1.19-2.78-2.22-1.06-1.03-1.81-2.08-2.26-2.71-.56-.79-1.34-1.87-2.94-1.87M158.75,216.79c.17,0,1.18,1.86,3.09,3.71,2.16,2.14,4.34,3.13,3.78,3.13,0,0-.02,0-.04,0v66.58h.04c.55,0-1.63.99-3.78,3.11-1.91,1.86-2.92,3.72-3.09,3.72-.02,0-.03-.03-.02-.11H13.88c.01.08,0,.11-.02.11-.16,0-1.18-1.86-3.09-3.72-2.15-2.12-4.34-3.11-3.78-3.11h.05v-66.58s-.03,0-.05,0c-.55,0,1.63-.99,3.78-3.13,1.91-1.85,2.92-3.71,3.09-3.71.03,0,.03.03.02.11h144.84c0-.08,0-.11.03-.11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13003"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13005",
    className: "cls-10",
    d: "M10.22,302.45c-.6,0-1.13-.35-1.37-.9-.24-.54-.14-1.18.26-1.62l3.67-4.03c.28-.31.69-.49,1.11-.49h144.84c.42,0,.83.18,1.12.49l3.67,4.03c.4.44.5,1.08.27,1.62-.24.55-.78.9-1.38.9H10.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13007"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13009",
    className: "cls-10",
    d: "M158.72,293.9H13.89c-.85,0-1.66.36-2.23.98l-3.67,4.03c-.8.88-1.01,2.15-.53,3.24.48,1.08,1.56,1.78,2.75,1.78h152.18c1.19,0,2.27-.7,2.75-1.78.48-1.09.27-2.36-.54-3.25l-3.67-4.03c-.57-.62-1.37-.98-2.22-.98M158.72,296.92l3.67,4.03H10.22l3.67-4.03h144.84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13011"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13013",
    className: "cls-10",
    d: "M3.01,295.53c-.2,0-.4-.04-.59-.12-.55-.24-.91-.78-.91-1.38v-74.24c0-.6.36-1.14.91-1.38.19-.08.39-.12.59-.12.38,0,.75.14,1.04.41l4.03,3.83c.3.28.47.68.47,1.09v66.57c0,.42-.17.8-.47,1.09l-4.03,3.83c-.28.27-.66.42-1.03.42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13015"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13017",
    className: "cls-10",
    d: "M3.01,216.78c-.4,0-.8.08-1.19.24-1.1.48-1.82,1.56-1.82,2.77v74.23c0,1.2.72,2.29,1.82,2.76.38.16.79.25,1.19.25.76,0,1.5-.29,2.07-.83l4.03-3.83c.59-.56.93-1.36.93-2.18v-66.58c0-.82-.33-1.61-.93-2.18l-4.03-3.83c-.57-.54-1.31-.83-2.07-.83M3.01,219.79l4.03,3.83v66.58l-4.03,3.83v-74.23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13019"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13021",
    className: "cls-10",
    d: "M169.61,295.53c-.38,0-.75-.14-1.03-.41l-4.03-3.83c-.3-.29-.47-.68-.47-1.09v-66.57c0-.42.17-.81.47-1.09l4.03-3.83c.28-.27.66-.41,1.03-.41.2,0,.4.04.59.12.55.24.91.78.91,1.38v74.24c0,.6-.36,1.14-.91,1.38-.2.08-.39.12-.6.12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13023"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13025",
    className: "cls-10",
    d: "M169.61,216.78c-.76,0-1.5.28-2.07.83l-4.03,3.83c-.6.57-.93,1.35-.93,2.18v66.58c0,.83.33,1.62.94,2.18l4.03,3.83c.57.54,1.31.83,2.07.83.4,0,.81-.08,1.19-.25,1.1-.48,1.82-1.56,1.82-2.76v-74.23c0-1.21-.72-2.29-1.82-2.76-.38-.17-.79-.25-1.19-.25M169.61,219.79v74.23l-4.03-3.83v-66.58l4.03-3.83"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13027"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13029",
    className: "cls-9",
    d: "M13.89,296.91l-3.67,4.03c-.01-.07-.02-.14-.02-.2l3.7-3.78s0-.03,0-.05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13031"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13033",
    className: "cls-9",
    d: "M13.89,296.96l-3.7,3.78c0-.11-.03-.22-.04-.32l3.72-3.4s.02-.02.02-.05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13035"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13037",
    className: "cls-9",
    d: "M13.87,297.02l-3.72,3.4c-.02-.13-.04-.25-.05-.37l3.74-3.03s.03,0,.03,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13039"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13041",
    className: "cls-9",
    d: "M13.84,297.02l-3.74,3.03c-.02-.14-.05-.28-.08-.42l3.75-2.69s.07.06.08.08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13043"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13045",
    className: "cls-9",
    d: "M13.76,296.94l-3.75,2.69c-.04-.15-.08-.3-.13-.44l3.74-2.42c.05.07.09.13.14.18"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13047"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13049",
    className: "cls-9",
    d: "M13.62,296.77l-3.73,2.41c-.06-.16-.1-.32-.16-.48l3.67-2.24c.09.12.16.22.22.31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13051"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13053",
    className: "cls-9",
    d: "M13.4,296.46l-3.67,2.24c-.08-.18-.17-.37-.25-.55l3.56-2.19c.14.19.26.35.36.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13055"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13057",
    className: "cls-9",
    d: "M13.04,295.96l-3.57,2.19c-.12-.24-.27-.48-.43-.71l3.35-2.33c.25.31.47.59.66.85"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13059"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13061",
    className: "cls-9",
    d: "M12.39,295.11l-3.35,2.33c-.29-.42-.65-.83-1.08-1.24-.6-.58-1.17-1.03-1.77-1.37l2.14-3.55c.7.5,1.58,1.18,2.46,2.04.64.62,1.17,1.25,1.61,1.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13063"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13065",
    className: "cls-9",
    d: "M8.32,291.27l-2.14,3.55c-.23-.12-.48-.23-.72-.33l2.14-3.73c.2.15.44.32.72.51"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13067"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13069",
    className: "cls-9",
    d: "M7.6,290.76l-2.14,3.73c-.19-.07-.38-.14-.59-.19l2.32-3.81c.1.07.24.17.41.27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13071"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13073",
    className: "cls-9",
    d: "M7.2,290.5l-2.32,3.81c-.17-.05-.33-.09-.52-.13l2.63-3.84s.12.09.21.16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13075"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13077",
    className: "cls-9",
    d: "M6.99,290.33l-2.63,3.84c-.15-.03-.3-.05-.47-.07l3.02-3.87s.03.06.08.09"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13079"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13081",
    className: "cls-9",
    d: "M6.91,290.24l-3.02,3.87c-.14-.03-.27-.04-.42-.06l3.46-3.84s-.03.02-.02.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13083"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13085",
    className: "cls-9",
    d: "M6.93,290.2l-3.46,3.84c-.11,0-.22-.01-.33-.02l3.87-3.83s-.06,0-.08,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13087"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13089",
    className: "cls-10",
    d: "M7,290.2l-3.87,3.83h-.12l4.03-3.83h-.04Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13091"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13093",
    className: "cls-3",
    d: "M7,290.2l-3.87,3.83h-.12l4.03-3.83h-.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13095"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13097",
    className: "cls-10",
    d: "M10.22,302.45c-.16,0-.32-.03-.48-.08-.56-.19-.96-.69-1.02-1.29-.15-1.67-.61-2.63-1.82-3.82-1.23-1.21-2.23-1.65-3.97-1.74-.6-.03-1.12-.42-1.33-.98-.21-.56-.06-1.2.38-1.61l3-2.85c.21-.2.43-.42.8-.85.3-.34.72-.51,1.14-.51.35,0,.7.12.99.36.07.07.14.14.2.22.09.06.19.13.32.22.78.53,2.09,1.41,3.41,2.72,1.32,1.29,2.26,2.6,2.75,3.3.09.11.15.21.21.3.07.05.14.12.2.19.54.62.49,1.55-.11,2.11q-.47.43-3.56,3.83c-.29.32-.7.49-1.11.49"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13099"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13101",
    className: "cls-10",
    d: "M6.91,287.21c-.84,0-1.68.35-2.28,1.04-.33.38-.53.58-.7.74l-2.99,2.85c-.88.83-1.17,2.1-.76,3.22.42,1.13,1.47,1.89,2.67,1.97,1.37.07,2.01.35,3,1.31.95.94,1.25,1.55,1.37,2.87.11,1.19.91,2.2,2.04,2.57.31.1.64.16.95.16.83,0,1.65-.35,2.23-.99,3.04-3.35,3.05-3.35,3.46-3.73,1.22-1.11,1.31-2.99.22-4.22-.07-.08-.14-.15-.21-.21-.03-.04-.07-.09-.1-.14-.53-.74-1.51-2.12-2.93-3.51-1.41-1.39-2.84-2.36-3.61-2.88-.06-.04-.11-.08-.16-.11-.07-.08-.15-.15-.23-.22-.57-.49-1.27-.73-1.97-.73M6.91,290.22c-.13.14,1.87,1.13,3.87,3.09,1.9,1.86,2.91,3.71,3.08,3.71h.01q-.53.48-3.66,3.92c-.19-2.04-.8-3.31-2.26-4.74-1.51-1.48-2.85-2.06-4.94-2.17l3-2.85c.22-.21.47-.45.9-.95"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13105",
    className: "cls-10",
    d: "M165.57,290.2l4.03,3.83h0l-4.03-3.83Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13109",
    className: "cls-3",
    d: "M165.57,290.2l4.03,3.83h0l-4.03-3.83"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13113",
    className: "cls-9",
    d: "M165.57,290.2l4.03,3.83c-.05,0-.11,0-.18.01l-3.8-3.84h-.05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13115"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13117",
    className: "cls-9",
    d: "M165.63,290.2l3.81,3.84c-.06,0-.12,0-.19.01l-3.58-3.84s-.02,0-.04,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13121",
    className: "cls-9",
    d: "M165.66,290.2l3.58,3.84c-.09,0-.18.02-.27.02l-3.26-3.85s-.01-.02-.04-.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13125",
    className: "cls-9",
    d: "M165.7,290.22l3.26,3.85c-.13.02-.27.04-.41.05l-2.87-3.85s.03-.04.02-.05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13129",
    className: "cls-9",
    d: "M165.7,290.27l2.86,3.85c-.19.04-.39.08-.58.12l-2.44-3.84c.08-.05.13-.1.15-.14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13133",
    className: "cls-9",
    d: "M165.54,290.4l2.44,3.84c-.27.07-.53.15-.78.25l-2.15-3.74c.22-.13.38-.25.5-.34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13137",
    className: "cls-9",
    d: "M165.04,290.75l2.15,3.74c-.9.33-1.69.88-2.53,1.71-.19.18-.36.35-.52.54l-3.07-2.62c.24-.26.49-.54.77-.81,1.23-1.22,2.47-2.06,3.21-2.56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13141",
    className: "cls-9",
    d: "M161.06,294.12l3.07,2.62c-.19.22-.37.44-.53.67l-3.35-2.35c.24-.3.51-.61.8-.94"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13145",
    className: "cls-9",
    d: "M160.26,295.06l3.35,2.35c-.12.16-.22.32-.32.5l-3.51-2.22c.15-.2.31-.41.49-.62"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13149",
    className: "cls-9",
    d: "M159.78,295.68l3.5,2.22c-.08.13-.16.27-.22.42l-3.61-2.2c.11-.13.21-.28.33-.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13153",
    className: "cls-9",
    d: "M159.45,296.12l3.61,2.2c-.07.11-.12.24-.17.37l-3.67-2.24c.07-.1.14-.21.22-.33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13157",
    className: "cls-9",
    d: "M159.23,296.45l3.66,2.24c-.03.1-.08.22-.11.34l-3.72-2.37c.04-.06.1-.14.17-.22"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13161",
    className: "cls-9",
    d: "M159.06,296.68l3.72,2.36c-.03.1-.07.21-.1.32l-3.73-2.51s.06-.1.11-.16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13163"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13165",
    className: "cls-9",
    d: "M158.94,296.84l3.74,2.51c-.03.08-.05.18-.08.27l-3.75-2.68s.05-.07.09-.1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13169",
    className: "cls-9",
    d: "M158.85,296.94l3.75,2.68c-.02.08-.04.18-.06.27l-3.74-2.9s.04-.04.05-.05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13173",
    className: "cls-9",
    d: "M158.8,297l3.74,2.89c-.01.08-.02.16-.04.24l-3.74-3.1s.02-.01.04-.03"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13177",
    className: "cls-9",
    d: "M158.76,297.02l3.74,3.11c-.02.07-.03.14-.03.22l-3.74-3.33s.01,0,.03,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13181",
    className: "cls-9",
    d: "M158.73,297.02l3.74,3.33c-.02.07-.03.14-.03.2l-3.72-3.55v.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13185",
    className: "cls-9",
    d: "M158.72,297l3.72,3.55c-.01.06-.02.11-.03.17l-3.7-3.75s0,.03,0,.03"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13189",
    className: "cls-9",
    d: "M158.72,296.97l3.7,3.76s0,.1-.03.15l-3.67-3.94s0,.03,0,.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13193",
    className: "cls-10",
    d: "M158.72,296.93l3.67,3.94v.07l-3.67-4.03v.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13197",
    className: "cls-3",
    d: "M158.72,296.93l3.67,3.94v.07l-3.67-4.03v.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13201",
    className: "cls-10",
    d: "M162.4,302.45c-.42,0-.82-.18-1.11-.49l-2.79-3.07c-.26-.27-.4-.42-.73-.72l1.01-1.12-1.08-1.02.24-.33c.5-.73,1.44-2.09,2.85-3.47,1.33-1.3,2.63-2.19,3.42-2.72.13-.09.24-.16.32-.22.06-.08.13-.15.21-.22.28-.24.62-.35.97-.35.42,0,.83.17,1.13.51q.45.51,3.81,3.71c.44.41.59,1.05.38,1.61-.21.56-.73.95-1.34.98-1.75.09-2.72.51-3.98,1.75-1.2,1.18-1.66,2.14-1.81,3.81-.06.6-.46,1.09-1.02,1.29-.16.05-.32.08-.48.08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13203"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13205",
    className: "cls-10",
    d: "M165.7,290.22q.5.57,3.91,3.81c-2.11.11-3.44.7-4.95,2.17-1.46,1.43-2.07,2.71-2.26,4.75l-2.79-3.07c-.31-.33-.47-.49-.84-.82h0c.13,0,1.15-1.88,3.07-3.75,1.99-1.96,3.98-2.94,3.87-3.09"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13207"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13209",
    className: "cls-9",
    d: "M158.72,216.9l3.67-4.03s0,.09.02.13l-3.7,3.87s0,.02,0,.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13213",
    className: "cls-9",
    d: "M158.72,216.86l3.69-3.87c0,.06,0,.13.02.19l-3.71,3.64s0,.03,0,.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13215"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13217",
    className: "cls-9",
    d: "M158.72,216.82l3.71-3.63c.01.08.01.16.04.25l-3.74,3.36s-.01.01-.01.03"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13221",
    className: "cls-9",
    d: "M158.73,216.79l3.74-3.36c0,.1.02.2.03.31l-3.74,3.05s-.02,0-.03,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13223"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13225",
    className: "cls-9",
    d: "M158.76,216.79l3.75-3.05c.02.13.05.25.07.38l-3.74,2.73s-.05-.05-.08-.07"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13227"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13229",
    className: "cls-9",
    d: "M158.84,216.85l3.75-2.73c.04.14.08.3.12.44l-3.74,2.45c-.05-.07-.1-.13-.13-.16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13233",
    className: "cls-9",
    d: "M158.97,217.02l3.74-2.46c.04.18.11.36.17.54l-3.67,2.25c-.1-.13-.17-.24-.24-.33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13237",
    className: "cls-9",
    d: "M159.21,217.35l3.67-2.25c.09.23.2.45.32.67l-3.54,2.21c-.18-.24-.33-.45-.45-.62"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13239"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13241",
    className: "cls-9",
    d: "M159.66,217.97l3.54-2.21c.23.44.53.84.9,1.26l-3.1,2.6c-.54-.61-.99-1.19-1.34-1.66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13243"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13245",
    className: "cls-9",
    d: "M161,219.63l3.1-2.6c.17.19.36.39.55.6.15.14.3.28.46.42l-2.61,3.08c-.22-.19-.44-.41-.67-.63-.3-.28-.59-.59-.83-.87"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13247"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13249",
    className: "cls-9",
    d: "M162.51,221.13l2.61-3.08c.43.37.86.68,1.3.93l-2.13,3.56c-.52-.37-1.13-.83-1.77-1.41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13251"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13253",
    className: "cls-9",
    d: "M164.28,222.53l2.13-3.56c.23.13.47.23.7.33l-2.12,3.72c-.2-.14-.44-.3-.71-.49"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13255"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13257",
    className: "cls-9",
    d: "M164.99,223.02l2.12-3.72c.17.07.36.14.54.19l-2.27,3.81c-.11-.08-.25-.17-.4-.27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13259"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13261",
    className: "cls-9",
    d: "M165.39,223.29l2.27-3.81c.16.05.31.09.47.11l-2.53,3.84c-.05-.04-.13-.09-.2-.15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13263"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13265",
    className: "cls-9",
    d: "M165.59,223.45l2.53-3.84c.12.03.25.05.39.08l-2.83,3.85s-.05-.04-.09-.09"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13267"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13269",
    className: "cls-9",
    d: "M165.68,223.53l2.83-3.85c.1.02.21.03.32.04l-3.13,3.86s0-.03-.02-.05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13271"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13273",
    className: "cls-9",
    d: "M165.7,223.59l3.13-3.86c.09.01.18.02.27.03l-3.42,3.85s.02-.01.02-.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13275"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13277",
    className: "cls-9",
    d: "M165.69,223.6l3.42-3.85c.06.01.14.02.21.02l-3.68,3.85s.04-.01.04-.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13279"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13281",
    className: "cls-9",
    d: "M165.64,223.62l3.68-3.84c.05,0,.11.01.16.01l-3.88,3.83h.03"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13283"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13285",
    className: "cls-10",
    d: "M165.61,223.62l3.88-3.83h.11l-4.03,3.83h.04Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13287"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13289",
    className: "cls-3",
    d: "M165.61,223.62l3.88-3.83h.11l-4.03,3.83h.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13291"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13293",
    className: "cls-10",
    d: "M165.7,225.1c-.34,0-.69-.11-.97-.36-.08-.07-.15-.14-.21-.21-.08-.06-.19-.13-.31-.21-.78-.53-2.09-1.42-3.43-2.75-1.31-1.29-2.24-2.6-2.75-3.3-.08-.11-.15-.21-.21-.29-.06-.05-.13-.11-.19-.18-.56-.61-.51-1.57.1-2.12q.48-.43,3.56-3.82c.3-.32.7-.49,1.11-.49.16,0,.32.03.48.08.56.19.97.69,1.02,1.29.15,1.69.6,2.62,1.82,3.82,1.24,1.2,2.24,1.65,3.97,1.73.6.03,1.13.42,1.34.98.21.56.07,1.2-.37,1.62l-3.01,2.85c-.21.21-.43.42-.8.84-.3.35-.72.53-1.14.53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13295"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13297",
    className: "cls-10",
    d: "M162.4,209.87c-.83,0-1.64.34-2.22.98-3.04,3.33-3.05,3.35-3.46,3.72-1.23,1.12-1.32,3.02-.21,4.24.07.07.13.14.2.2.03.04.07.09.1.15.53.74,1.52,2.11,2.93,3.5,1.42,1.41,2.86,2.38,3.62,2.91.05.04.11.08.16.11.08.08.16.15.25.23.56.48,1.25.71,1.94.71.85,0,1.69-.36,2.28-1.05.32-.38.51-.56.7-.74l2.99-2.84c.88-.83,1.17-2.1.75-3.23-.42-1.13-1.47-1.9-2.67-1.96-1.36-.07-2.01-.35-3-1.31-.94-.93-1.24-1.55-1.36-2.87-.11-1.18-.91-2.2-2.04-2.57-.32-.11-.64-.16-.96-.16M162.4,212.88c.19,2.04.8,3.31,2.26,4.75,1.51,1.47,2.84,2.06,4.95,2.16l-3,2.85c-.24.23-.48.47-.9.96.11-.14-1.88-1.13-3.87-3.1-1.9-1.86-2.92-3.71-3.09-3.71,0,0-.01,0-.02,0q.53-.48,3.66-3.91"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13299"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13301",
    className: "cls-10",
    d: "M7.04,223.62l-4.03-3.83h.07l3.95,3.83h.01Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13303"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13305",
    className: "cls-3",
    d: "M7.04,223.62l-4.03-3.83h.07l3.95,3.83h.01"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13307"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13309",
    className: "cls-9",
    d: "M7.03,223.62l-3.95-3.83s.1,0,.14,0l3.76,3.84h.05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13313",
    className: "cls-9",
    d: "M6.98,223.62l-3.76-3.84c.06,0,.11,0,.17-.01l3.55,3.85h.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13315"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13317",
    className: "cls-9",
    d: "M6.94,223.62l-3.55-3.85c.07,0,.12-.02.19-.02l3.35,3.85s.01.01.02.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13319"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13321",
    className: "cls-9",
    d: "M6.92,223.6l-3.35-3.86c.08,0,.14-.01.22-.02l3.12,3.87.02.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13323"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13325",
    className: "cls-9",
    d: "M6.91,223.59l-3.12-3.87c.08,0,.15-.02.24-.03l2.9,3.86s-.02.03-.02.03"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13327"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13329",
    className: "cls-9",
    d: "M6.92,223.55l-2.9-3.85c.09-.02.17-.03.26-.05l2.68,3.85s-.04.04-.04.05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13331"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13333",
    className: "cls-9",
    d: "M6.96,223.5l-2.68-3.85c.09-.01.19-.03.27-.05l2.49,3.84s-.06.05-.09.07"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13335"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13337",
    className: "cls-9",
    d: "M7.05,223.43l-2.49-3.84c.1-.03.2-.05.31-.08l2.32,3.81c-.05.04-.1.07-.14.1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13339"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13341",
    className: "cls-9",
    d: "M7.19,223.33l-2.32-3.82c.1-.03.21-.06.32-.1l2.2,3.78c-.07.05-.14.09-.19.14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13343"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13345",
    className: "cls-9",
    d: "M7.38,223.19l-2.2-3.77c.11-.03.22-.08.33-.12l2.12,3.72c-.09.07-.18.12-.26.18"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13347"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13349",
    className: "cls-9",
    d: "M7.64,223.01l-2.12-3.71c.12-.05.24-.1.35-.16l2.11,3.65c-.11.08-.23.15-.33.22"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13351"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13353",
    className: "cls-9",
    d: "M7.97,222.79l-2.11-3.64c.12-.06.25-.13.37-.19l2.14,3.55c-.13.1-.27.2-.4.28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13357",
    className: "cls-9",
    d: "M8.38,222.5l-2.14-3.55c.14-.08.27-.16.41-.26l2.24,3.42c-.18.14-.36.27-.52.38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13359"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13361",
    className: "cls-9",
    d: "M8.9,222.11l-2.24-3.42c.16-.1.32-.22.48-.34l2.43,3.24c-.22.19-.45.37-.67.53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13363"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13365",
    className: "cls-9",
    d: "M9.56,221.59l-2.43-3.24c.2-.16.4-.33.61-.53l2.72,2.98c-.3.28-.6.54-.9.78"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13367"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13369",
    className: "cls-9",
    d: "M10.46,220.8l-2.72-2.98c.07-.07.14-.13.21-.2.28-.28.54-.56.76-.83l3.2,2.49c-.33.39-.72.8-1.14,1.22-.1.1-.21.2-.32.31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13371"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13373",
    className: "cls-9",
    d: "M11.92,219.28l-3.2-2.49c.35-.43.62-.85.83-1.3l3.62,2.18c-.31.44-.73,1-1.25,1.61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13375"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13377",
    className: "cls-9",
    d: "M13.17,217.68l-3.61-2.19c.17-.36.31-.73.41-1.12l3.75,2.56c-.11.15-.31.41-.55.74"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13379"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13381",
    className: "cls-9",
    d: "M13.71,216.93l-3.75-2.56c.06-.21.1-.42.14-.64l3.75,3.07s-.08.06-.14.14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13383"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13385",
    className: "cls-9",
    d: "M13.85,216.79l-3.75-3.06c.03-.13.04-.26.06-.39l3.72,3.47s-.01-.02-.03-.01"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13387"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13389",
    className: "cls-9",
    d: "M13.89,216.8l-3.72-3.47c0-.08.02-.17.03-.26l3.7,3.77s0-.03,0-.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13391"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13393",
    className: "cls-9",
    d: "M13.89,216.85l-3.7-3.77c.01-.07.01-.13.02-.2l3.67,4.02v-.05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13395"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13397",
    className: "cls-9",
    d: "M13.89,216.9l-3.67-4.02h0s3.67,4.02,3.67,4.02h0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13399"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13401",
    className: "cls-10",
    d: "M6.91,225.1c-.42,0-.83-.18-1.13-.51q-.46-.52-3.82-3.72c-.44-.41-.58-1.05-.37-1.61.21-.57.73-.95,1.34-.98,1.72-.08,2.72-.53,3.97-1.74,1.21-1.19,1.65-2.12,1.81-3.81.05-.6.46-1.1,1.02-1.29.15-.05.32-.08.48-.08.42,0,.82.18,1.12.49l2.78,3.06c.34.36.47.49.73.72l-1.01,1.12,1.09,1.01-.22.32c-.47.67-1.45,2.09-2.88,3.48-1.32,1.31-2.63,2.21-3.42,2.74-.12.08-.23.15-.31.21-.05.07-.12.14-.19.2-.28.25-.64.37-.99.37"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13403"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13405",
    className: "cls-10",
    d: "M10.22,212.87l2.78,3.06c.33.34.47.49.84.83h0c-.13,0-1.14,1.87-3.06,3.73-1.98,1.97-3.99,2.96-3.86,3.1q-.5-.57-3.9-3.81c2.1-.1,3.44-.69,4.94-2.16,1.46-1.43,2.07-2.71,2.26-4.75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13407"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13409",
    className: "cls-10",
    d: "M33.77,253.55c-2.5,0-4.68-.33-7.76-1.19-.59-.16-1.02-.67-1.09-1.27l-.62-5.22c-.04-.4.07-.8.32-1.11.25-.32.62-.52,1.01-.56,0,0,.73-.07.78-.07.42,0,.81.18,1.1.48,1.26,1.36,3.1,2.02,5.6,2.02,1.86,0,3.26-.61,3.26-1.41,0-.22,0-.75-2.47-1.76-5.34-2.18-7.33-3.34-8.56-5.92-.43-.87-.65-1.85-.65-2.89,0-4.76,4.28-8.09,10.4-8.09,1.57,0,3.12.19,5.03.62.43.1.8.14.9.14.04,0,.12,0,.35-.08.16-.06.33-.09.51-.09h.74c.83,0,1.51.67,1.51,1.5v5.69c0,.83-.67,1.5-1.51,1.5h-.74c-.43,0-.84-.19-1.12-.5-1.08-1.22-2.78-1.89-4.8-1.89-1.31,0-2.12.45-2.12.87,0,.01.13.33,1.24.83l3.12,1.31c3.77,1.58,7.26,3.7,7.26,8.46,0,5.24-4.59,8.63-11.68,8.63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13411"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13413",
    className: "cls-10",
    d: "M35.08,225.06c-7.01,0-11.89,3.94-11.89,9.6,0,1.27.27,2.46.79,3.55,1.53,3.18,4.02,4.47,9.35,6.64.2.08.38.16.54.23-.22.03-.48.04-.77.04-2.74,0-3.88-.88-4.5-1.54-.57-.61-1.37-.96-2.2-.96-.1,0-.21,0-.32.02l-.62.07c-.8.08-1.53.49-2.03,1.12-.5.62-.73,1.43-.64,2.23l.62,5.22c.14,1.21,1.01,2.22,2.18,2.55,3.23.89,5.52,1.24,8.17,1.24,7.88,0,13.18-4.07,13.18-10.14,0-3.61-1.69-5.93-3.97-7.58,1.49-.18,2.64-1.45,2.64-2.99v-5.69c0-1.66-1.35-3.01-3.01-3.01h-.74c-.33,0-.66.05-.97.15-.12-.01-.3-.04-.48-.08-2.01-.45-3.67-.66-5.35-.66M35.08,228.07c1.44,0,2.88.17,4.7.58.49.11.99.17,1.24.17s.49-.04.86-.17h.74v5.69h-.74c-1.36-1.54-3.46-2.39-5.92-2.39-2.18,0-3.63.96-3.63,2.36,0,.87.66,1.55,2.14,2.2.38.17,1.45.61,3.14,1.33,4.6,1.93,6.34,3.85,6.34,7.07,0,4.35-4,7.13-10.17,7.13-2.35,0-4.4-.31-7.36-1.13l-.62-5.22.62-.06c1.57,1.68,3.78,2.5,6.7,2.5s4.77-1.17,4.77-2.92c0-1.26-.9-2.14-3.42-3.15-5.3-2.16-6.79-3.13-7.77-5.18-.34-.69-.49-1.44-.49-2.23,0-3.91,3.62-6.59,8.89-6.59"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13415"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13417",
    className: "cls-10",
    d: "M50.51,253c-.39,0-.78-.15-1.06-.43-.28-.28-.45-.67-.45-1.07v-.55c0-.74.55-1.38,1.29-1.49.39-.05.8-.11.8-3.72v-11.39h-.22c-3.16,0-3.39.41-3.54.68-.26.49-.77.79-1.32.79h-.66c-.43,0-.83-.18-1.12-.5-.28-.32-.42-.74-.37-1.17l.66-5.66c.09-.76.73-1.33,1.49-1.33h19.67c.77,0,1.41.57,1.5,1.33l.66,5.66c.05.43-.09.85-.37,1.18s-.7.5-1.12.5h-.67c-.55,0-1.06-.3-1.32-.79-.15-.27-.37-.68-3.53-.68h-.34v11.39c0,3.6.44,3.66.91,3.72.74.1,1.3.74,1.3,1.49v.55c0,.4-.16.78-.45,1.06-.28.28-.66.44-1.05.44-.01,0-2.16-.03-2.16-.03-1.13-.02-1.99-.03-3.28-.03s-2.1.02-3.19.03c0,0-2.07.03-2.07.03"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13419"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13421",
    className: "cls-10",
    d: "M65.69,225.65h-19.67c-1.53,0-2.81,1.14-2.99,2.66l-.66,5.67c-.1.85.17,1.71.74,2.34.57.65,1.39,1.01,2.24,1.01h.66c1,0,1.93-.5,2.49-1.32.18-.04.5-.09,1.08-.12v9.86c0,1.26-.05,1.99-.11,2.39-1.16.44-1.98,1.55-1.98,2.82v.55c0,.8.32,1.58.89,2.14.56.56,1.32.87,2.12.87h.04l2.06-.03c1.07-.02,1.89-.04,3.16-.04s2.13.02,3.25.04l2.14.03h.03c.79,0,1.55-.31,2.12-.87.57-.57.89-1.34.89-2.14v-.55c0-1.33-.87-2.48-2.1-2.87-.06-.38-.12-1.09-.12-2.34v-9.87c.66.03,1.01.08,1.2.13.56.82,1.49,1.32,2.49,1.32h.67c.85,0,1.67-.36,2.24-1.01.57-.64.84-1.49.74-2.35l-.66-5.66c-.18-1.52-1.46-2.66-2.99-2.66M65.69,228.66l.67,5.66h-.67c-.61-1.13-1.76-1.47-4.85-1.47h-1.86v12.89c0,3.81.49,4.97,2.22,5.21v.55c-2.46-.03-3.44-.07-5.43-.07s-2.87.03-5.26.07v-.55c1.64-.24,2.09-1.3,2.09-5.21v-12.89h-1.72c-3.09,0-4.24.33-4.86,1.47h-.66l.66-5.66h19.67"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13423"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13425",
    className: "cls-10",
    d: "M82.7,235.93c2.55,0,2.72-.39,2.86-.71.16-.36.44-.64.79-.78-.33-.1-.85-.17-1.71-.17h-4.58v1.66h2.65ZM80.09,245.84c.2.02.51.03,1.01.03h2.97c3.16,0,3.39-.63,3.48-.87.07-.16.15-.32.26-.44-.05,0-.82,0-.82,0-.59,0-1.12-.34-1.37-.88-.14-.31-.29-.63-2.79-.63h-2.73s0,2.74,0,2.79M70.1,253c-.83,0-1.51-.67-1.51-1.5v-.55c0-.73.53-1.36,1.26-1.48.39-.07.8-.14.8-3.73v-11.36c0-3.58-.35-3.62-.8-3.69-.74-.1-1.29-.74-1.29-1.49v-.55c0-.83.67-1.51,1.51-1.51h18.93c.83,0,1.51.67,1.51,1.51v5.69c0,.78-.6,1.42-1.36,1.49v.08c-.09,1.33-.08,1.82-.08,3.02,0,.87,0,1.89.04,3.14l.04.91c.02.38-.11.75-.36,1.04.05,0,.27,0,.32,0l.7.07c.41.04.78.24,1.03.55.25.32.36.72.31,1.13l-.74,5.9c-.09.76-.73,1.31-1.49,1.31h-18.81Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13427"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13429",
    className: "cls-10",
    d: "M89,225.65h-18.94c-1.66,0-3,1.35-3,3.01v.54c0,1.29.82,2.41,1.99,2.83.05.42.09,1.13.09,2.35v11.35c0,1.29-.05,2.01-.11,2.4-1.14.44-1.94,1.55-1.94,2.81v.55c0,1.66,1.35,3.01,3.01,3.01h18.81c1.51,0,2.8-1.13,2.98-2.63l.74-5.9c.11-.8-.13-1.62-.63-2.25-.36-.45-.84-.79-1.37-.97l-.03-.76c-.04-1.2-.04-2.21-.04-3.06s0-1.34.03-2.05c.85-.53,1.42-1.48,1.42-2.55v-5.69c0-1.66-1.35-3.01-3.01-3.01M87.64,235.83h.02M89,228.66v5.69h-.66c-.55-1.17-1.49-1.58-3.71-1.58h-6.09v4.67h4.16c2.63,0,3.7-.38,4.24-1.61h.7c-.08,1.37-.08,1.88-.08,3.12,0,.89,0,1.92.04,3.2l.04.92h-.65c-.54-1.17-1.48-1.51-4.16-1.51h-4.24v4.14c-.04,1.45.36,1.68,2.51,1.68h2.96c3.01,0,4.4-.51,4.9-1.85l.7.07-.74,5.9h-18.81v-.55c1.61-.27,2.06-1.37,2.06-5.21v-11.35c0-3.95-.42-4.94-2.1-5.18v-.54h18.94"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13431"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13433",
    className: "cls-10",
    d: "M105.85,241.73l-.89-1.8-.85,1.8h1.75ZM117.78,252.97c-.79-.02-1.4-.03-2.35-.03,0,0-5.42.07-5.43.07-.39,0-.77-.16-1.06-.43-.28-.28-.45-.67-.45-1.07v-.55c0-.6.35-1.12.87-1.36-.06-.16-.09-.25-.11-.31l-.33-.59h-7.99l-.55,1c.43.3.77.77.77,1.26v.55c0,.4-.16.79-.45,1.07-.28.27-.66.43-1.06.43,0,0-5.48-.07-5.48-.07-.86,0-1.36.02-2.01.03,0,0-1.19.03-1.2.03-.39,0-.77-.16-1.05-.43-.29-.28-.45-.67-.45-1.07v-.55c0-.54.29-1.04.77-1.31.3-.16.51-.34,1.4-1.95l11.94-21.03c.26-.47.76-.76,1.31-.76h.83c.55,0,1.06.3,1.32.77l11.6,21.03c.67,1.28,1.09,1.72,1.52,1.98.45.27.72.76.72,1.29v.55c0,.4-.16.79-.44,1.07-.29.27-.67.43-1.06.43-.01,0-1.56-.03-1.56-.03"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13435"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13437",
    className: "cls-10",
    d: "M105.67,224.38h-.84c-1.08,0-2.08.58-2.62,1.52l-11.94,21.02c-.59,1.08-.8,1.36-.88,1.45-.94.53-1.48,1.49-1.48,2.58v.55c0,.81.33,1.59.9,2.15.56.55,1.32.85,2.11.85h.06l1.17-.03c.64-.02,1.13-.04,1.98-.04.42,0,.88.01,1.38.02.63.01,1.32.02,2.08.02l1.97.03h.05c.79,0,1.55-.31,2.11-.86.57-.57.89-1.34.89-2.15v-.55c0-.26-.03-.52-.1-.76h4.56c-.06.24-.09.5-.09.76v.55c0,.8.32,1.58.89,2.15.56.55,1.32.86,2.11.86h.04l1.97-.03h.04c.67,0,1.32-.01,1.94-.02.51-.01.99-.02,1.44-.02.94,0,1.54.02,2.32.04l1.54.03h.05c.79,0,1.55-.31,2.11-.86.57-.56.9-1.34.9-2.15v-.55c0-1.05-.54-2.03-1.44-2.57-.1-.06-.36-.22-.96-1.37l-11.63-21.08c-.53-.96-1.53-1.55-2.63-1.55M101.72,243.23h6.55l-3.35-6.76-3.2,6.76M105.67,227.39l11.6,21.02c.73,1.41,1.32,2.09,2.06,2.54v.55c-1.77-.03-2.43-.06-3.91-.06-.99,0-2.14.03-3.47.03l-1.97.03v-.55c.7-.1,1.06-.41,1.06-.89,0-.15-.04-.32-.13-.56-.12-.31-.21-.51-.24-.61l-.91-1.71h-9.76l-1.11,2.01c-.2.38-.28.62-.28.82,0,.48.28.76.99.93v.55l-2.02-.03c-1.36,0-2.51-.03-3.46-.03-1.31,0-1.81.03-3.21.06v-.55c.66-.37,1.02-.82,1.97-2.54l11.94-21.02h.84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13439"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13441",
    className: "cls-10",
    d: "M143.33,253.21c-3.3,0-5.07-.34-6.86-2.41l-5.8-6.5v1.44c0,3.6.43,3.66.85,3.72.74.1,1.29.74,1.29,1.49v.55c0,.4-.16.79-.45,1.07s-.66.44-1.06.44c-.01,0-2.34-.03-2.34-.03-1.14-.02-2-.03-3.18-.03,0,0-5.09.07-5.1.07-.39,0-.77-.16-1.06-.43-.29-.28-.45-.67-.45-1.07v-.55c0-.75.55-1.38,1.29-1.49.39-.05.76-.11.76-3.72v-11.32c0-3.62-.37-3.67-.76-3.73-.74-.11-1.29-.74-1.29-1.48v-.55c0-.83.67-1.5,1.51-1.5h2.05c1.42.03,2.44.03,3.17.03h0c.68,0,1.75,0,3.17-.03h2.22c.83,0,1.51.67,1.51,1.5v.55c0,.74-.55,1.37-1.29,1.48-.42.06-.85.13-.85,3.73v.31s4.64-4.47,4.65-4.48c-.3-.28-.49-.65-.49-1.04v-.55c0-.83.67-1.5,1.5-1.5l5.24.03,3.56-.03h1.9c.83,0,1.51.67,1.51,1.5v.55c0,.71-.49,1.31-1.19,1.47-.86.19-1.58.55-3.15,2.03l-6.64,6.19,8.44,9.05c1.19,1.25,1.52,1.43,2.03,1.55.67.17,1.14.77,1.14,1.46v.55c0,.82-.65,1.48-1.46,1.51l-.99.03-2.03.1c-.42.04-.87.08-1.35.08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13443"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13445",
    className: "cls-10",
    d: "M147.03,225.65h-1.89l-3.61.03-3.56-.03h-1.64c-1.05,0-1.97.54-2.51,1.35-.54-.81-1.46-1.35-2.51-1.35h-2.18c-1.48.03-2.53.03-3.21.03h-.02c-.73,0-1.72,0-3.08-.03h-2.12c-1.66,0-3.01,1.35-3.01,3.01v.54c0,1.28.79,2.38,1.94,2.81.05.42.1,1.14.1,2.41v11.32c0,1.26-.05,1.99-.1,2.4-1.14.45-1.94,1.55-1.94,2.81v.55c0,.8.32,1.58.89,2.14.56.56,1.32.87,2.11.87h.04l2.33-.03c.95,0,1.72-.02,2.78-.04,1.12,0,1.97.02,3.1.03l2.33.04h.03c.79,0,1.55-.31,2.11-.87.57-.57.89-1.34.89-2.14v-.55c0-.11,0-.21-.02-.32l1.06,1.19c2.12,2.44,4.36,2.9,7.97,2.9.53,0,1.01-.04,1.51-.08l1.97-.1.94-.03c1.62-.05,2.9-1.38,2.9-3.01v-.55c0-1.38-.93-2.58-2.27-2.92-.14-.03-.31-.08-1.32-1.14l-7.39-7.93,5.53-5.16c1.45-1.36,1.95-1.55,2.45-1.66,1.38-.3,2.38-1.52,2.38-2.94v-.54c0-1.66-1.35-3.01-3.01-3.01M147.03,228.66v.54c-1.28.28-2.27.89-3.87,2.4l-7.74,7.21,9.46,10.16c1.24,1.3,1.82,1.75,2.77,1.99v.55l-1,.03-2.05.1c-.42.04-.83.07-1.28.07-3.26,0-4.41-.38-5.73-1.89l-8.44-9.47v5.39c0,3.84.46,4.97,2.15,5.21v.55c-2.59-.03-3.66-.07-5.52-.07-1.77.03-2.76.03-5.09.07v-.55c1.63-.24,2.05-1.26,2.05-5.21v-11.32c0-3.95-.42-4.98-2.05-5.22v-.54h2.05c1.4.03,2.42.03,3.17.03.7,0,1.77,0,3.21-.03h2.18v.54c-1.69.25-2.15,1.38-2.15,5.22v3.84l7.16-6.9c.83-.78,1.03-1.06,1.03-1.44,0-.41-.37-.65-1.03-.72v-.54h1.62l3.62.03,3.58-.03h1.89"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13447"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13449",
    className: "cls-10",
    d: "M32.2,286.38c-2.51,0-4.69-.33-7.77-1.19-.59-.16-1.02-.67-1.09-1.27l-.62-5.21c-.04-.4.07-.8.32-1.12.25-.31.61-.51,1.01-.56,0,0,.73-.08.78-.08.42,0,.81.18,1.1.48,1.27,1.36,3.1,2.03,5.61,2.03,1.87,0,3.27-.61,3.27-1.41,0-.22,0-.74-2.49-1.76-5.33-2.17-7.31-3.33-8.56-5.91-.43-.91-.65-1.87-.65-2.89,0-4.76,4.28-8.09,10.4-8.09,1.58,0,3.13.19,5.03.62.34.07.71.13.9.13.17-.06.68-.17.86-.17h.74c.83,0,1.51.67,1.51,1.51v5.69c0,.83-.68,1.5-1.51,1.5h-.74c-.43,0-.84-.18-1.13-.51-1.07-1.22-2.78-1.89-4.8-1.89-1.3,0-2.11.44-2.11.85,0,.02.14.34,1.23.82.24.11,3.12,1.34,3.12,1.34,3.76,1.57,7.25,3.68,7.25,8.45,0,5.25-4.58,8.64-11.67,8.64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13451"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13453",
    className: "cls-10",
    d: "M33.51,257.89c-7.01,0-11.9,3.94-11.9,9.6,0,1.23.26,2.41.78,3.51,1.57,3.23,4.05,4.52,9.37,6.68.2.08.38.16.54.23-.22.03-.48.05-.77.05-2.06,0-3.54-.51-4.51-1.55-.57-.61-1.37-.96-2.2-.96-.11,0-.22,0-.33.02l-.62.07c-.79.09-1.52.49-2.02,1.12-.5.62-.72,1.43-.63,2.22l.62,5.21c.14,1.21,1.01,2.22,2.18,2.55,3.22.89,5.51,1.24,8.17,1.24,7.88,0,13.17-4.07,13.17-10.14,0-3.61-1.68-5.93-3.95-7.58,1.48-.19,2.63-1.45,2.63-2.98v-5.69c0-1.66-1.35-3.01-3.01-3.01h-.74c-.32,0-.65.05-.96.16-.14-.02-.34-.05-.54-.1-1.94-.44-3.59-.65-5.29-.65M33.51,260.9c1.44,0,2.88.17,4.7.59.49.1.99.17,1.24.17s.49-.03.85-.17h.74v5.69h-.74c-1.35-1.54-3.45-2.4-5.93-2.4-2.18,0-3.61.95-3.61,2.36,0,.87.66,1.55,2.14,2.2.37.18,1.44.62,3.13,1.34,4.61,1.92,6.34,3.84,6.34,7.07,0,4.36-3.99,7.13-10.17,7.13-2.35,0-4.4-.31-7.37-1.13l-.62-5.21.62-.07c1.57,1.68,3.79,2.5,6.71,2.5s4.78-1.17,4.78-2.92c0-1.27-.91-2.12-3.42-3.15-5.31-2.16-6.79-3.13-7.77-5.18-.33-.69-.5-1.45-.5-2.23,0-3.91,3.62-6.59,8.89-6.59"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13455"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13457",
    className: "cls-10",
    d: "M57.72,274.55l-.89-1.8-.85,1.8h1.74ZM61.87,285.82c-.39,0-.77-.15-1.06-.43-.28-.28-.45-.67-.45-1.07v-.55c0-.6.36-1.13.87-1.37l-.05-.13-.42-.77h-7.96l-.56,1.01c.43.3.76.77.76,1.26v.55c0,.4-.16.78-.45,1.07-.28.27-.66.43-1.06.43,0,0-5.47-.07-5.47-.07-.9,0-1.42.02-2.12.04,0,0-1.07.03-1.09.03-.39,0-.77-.15-1.05-.43-.29-.28-.46-.67-.46-1.07v-.55c0-.54.3-1.04.77-1.31.3-.17.51-.34,1.4-1.95l11.95-21.04c.26-.47.77-.76,1.31-.76h.83c.54,0,1.05.3,1.31.78l11.61,21.02c.7,1.31,1.1,1.73,1.51,1.97.45.27.73.77.73,1.3v.55c0,.4-.16.79-.45,1.07-.28.27-.66.43-1.05.43-.01,0-1.43-.03-1.43-.03-.86-.02-1.48-.03-2.49-.03,0,0-5.43.07-5.44.07"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13459"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13461",
    className: "cls-10",
    d: "M57.56,257.2h-.83c-1.08,0-2.08.58-2.62,1.52l-11.94,21.02c-.59,1.07-.8,1.36-.88,1.45-.94.53-1.48,1.49-1.48,2.58v.55c0,.81.33,1.59.91,2.15.56.55,1.32.85,2.1.85h.07l1.06-.03c.68-.02,1.18-.04,2.07-.04.42,0,.88.01,1.38.02.63,0,1.32.02,2.07.02l1.97.03h.05c.79,0,1.55-.31,2.11-.86.57-.56.9-1.34.9-2.15v-.55c0-.27-.03-.52-.1-.77h4.55c-.06.25-.1.5-.1.77v.55c0,.8.33,1.58.9,2.15.56.55,1.31.86,2.11.86h.05l1.98-.03h.05c.65,0,1.31-.01,1.92-.02.51,0,.99-.02,1.43-.02.99,0,1.6.02,2.44.04l1.41.03h.06c.78,0,1.54-.31,2.11-.86.57-.56.9-1.34.9-2.15v-.55c0-1.06-.56-2.05-1.47-2.59-.25-.15-.65-.82-.93-1.35l-11.63-21.07c-.53-.96-1.54-1.55-2.63-1.55M53.6,276.05h6.54l-3.33-6.76-3.21,6.76M57.56,260.22l11.61,21.02c.74,1.41,1.31,2.1,2.05,2.54v.55c-1.77-.03-2.43-.07-3.91-.07-.99,0-2.14.03-3.46.03l-1.98.03v-.55c.71-.11,1.08-.41,1.08-.89,0-.13-.04-.31-.13-.55-.12-.32-.2-.51-.24-.61l-.91-1.72h-9.75l-1.12,2.01c-.21.38-.28.62-.28.84,0,.48.28.75.99.92v.55l-2.02-.03c-1.36,0-2.51-.03-3.45-.03-1.31,0-1.82.03-3.21.07v-.55c.66-.37,1.02-.82,1.97-2.54l11.94-21.02h.83"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13463"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13465",
    className: "cls-10",
    d: "M83.61,286.38c-7.99,0-12.95-3.89-12.95-10.14v-8.99c0-3.63-.43-3.68-.75-3.72-.75-.1-1.31-.74-1.31-1.49v-.54c0-.83.67-1.51,1.51-1.51h2.06l3.1.04,3.26-.04h2.07c.84,0,1.51.67,1.51,1.51v.54c0,.74-.55,1.38-1.29,1.49-.38.05-.78.11-.78,3.73v7.06c0,2.61.31,3.45.77,3.92.57.6,1.74.96,3.04.96,1.77,0,2.99-.66,3.38-1.28.41-.65.5-.92.5-4.05v-6.62c0-3.62-.36-3.67-.73-3.73-.74-.11-1.29-.74-1.29-1.49v-.54c0-.83.67-1.51,1.51-1.51h2.02l3.23.04,3.22-.04h2.07c.83,0,1.51.67,1.51,1.51v.54c0,.76-.56,1.4-1.32,1.49-.37.04-.83.1-.83,3.72v6.89c0,4.62-.34,6.4-2.5,8.55-2.45,2.45-6.15,3.7-11.02,3.7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13467"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13469",
    className: "cls-10",
    d: "M97.77,258.47h-2.05l-3.29.03-3.15-.03h-2.05c-1.66,0-3.01,1.35-3.01,3.01v.54c0,1.26.78,2.36,1.92,2.8.05.42.1,1.14.1,2.41v6.62c0,2.81-.09,2.95-.27,3.24-.11.14-.85.57-2.1.57s-1.83-.36-1.95-.49c-.06-.06-.36-.43-.36-2.88v-7.07c0-1.28.05-2,.11-2.41,1.14-.44,1.95-1.54,1.95-2.8v-.54c0-1.66-1.35-3.01-3.01-3.01h-2.06s-3.32.03-3.32.03l-3.03-.03h-2.1c-1.66,0-3.01,1.35-3.01,3.01v.54c0,1.28.8,2.38,1.95,2.81.05.41.11,1.13.11,2.4v8.99c0,7.19,5.54,11.65,14.45,11.65,5.28,0,9.35-1.4,12.09-4.14,2.64-2.63,2.93-5.06,2.93-9.61v-6.89c0-1.26.06-1.98.12-2.38,1.18-.42,2.03-1.54,2.03-2.84v-.54c0-1.66-1.35-3.01-3.01-3.01M97.77,261.49v.54c-1.65.21-2.14,1.34-2.14,5.21v6.89c0,4.46-.33,5.77-2.06,7.48-2.18,2.2-5.56,3.26-9.96,3.26-7.2,0-11.45-3.2-11.45-8.64v-8.99c0-3.88-.45-5-2.06-5.21v-.54h2.06l3.09.03,3.29-.03h2.06v.54c-1.61.24-2.06,1.3-2.06,5.21v7.07c0,2.75.32,4.08,1.2,4.97.86.89,2.38,1.41,4.12,1.41,2.1,0,3.91-.79,4.65-1.98.65-1.03.73-1.69.73-4.84v-6.62c0-3.95-.41-4.98-2.03-5.21v-.54h2.03l3.21.03,3.26-.03h2.05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13471"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13473",
    className: "cls-10",
    d: "M116,286.38c-3.79,0-6.67-.61-9.3-1.99-4.53-2.39-7.23-6.72-7.23-11.58,0-6.03,4.24-11.2,10.55-12.84,1.49-.38,3.21-.57,5.12-.57,2.05,0,3.71.19,5.92.69.51.11.9.17,1.16.17.24-.16.45-.27.74-.27h.77c.83,0,1.51.67,1.51,1.51v5.69c0,.83-.67,1.5-1.51,1.5h-.57c-.31,0-.61-.09-.87-.27-1.72-1.22-3.62-1.79-5.97-1.79-4.36,0-7.3,2.51-7.3,6.25s2.93,6.32,7.3,6.32c2.43,0,4.59-.71,6.1-2.01.28-.24.62-.36.98-.36.08,0,.15,0,.24.02l.67.1c.8.13,1.36.87,1.26,1.68l-.67,5.35c-.08.6-.51,1.09-1.09,1.26-3.28.91-4.95,1.16-7.81,1.16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13475"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13477",
    className: "cls-10",
    d: "M115.14,257.89c-2.04,0-3.88.21-5.48.61-7,1.82-11.69,7.57-11.69,14.3,0,5.43,3,10.25,8.03,12.92,2.87,1.49,5.96,2.16,10.01,2.16,2.98,0,4.82-.27,8.21-1.21,1.17-.32,2.03-1.31,2.18-2.52l.67-5.35c.2-1.61-.91-3.09-2.52-3.34l-.66-.11c-.16-.02-.31-.03-.47-.03-.71,0-1.41.25-1.95.73-1.24,1.05-3.06,1.64-5.12,1.64-2.8,0-5.79-1.26-5.79-4.81s2.99-4.75,5.79-4.75c2.05,0,3.62.47,5.1,1.51.51.36,1.12.55,1.74.55h.57c1.66,0,3.01-1.35,3.01-3.01v-5.69c0-1.66-1.34-3.01-3.01-3.01h-.78c-.39,0-.78.08-1.14.22-.11-.02-.26-.04-.44-.09-2.33-.52-4.08-.72-6.24-.72M115.14,260.9c1.93,0,3.45.17,5.59.65.59.13,1.08.2,1.49.2.28,0,.45-.08.74-.27h.78v5.69h-.57c-1.94-1.37-4.12-2.06-6.84-2.06-5.23,0-8.8,3.15-8.8,7.75s3.57,7.82,8.8,7.82c2.75,0,5.27-.82,7.08-2.37l.67.1-.67,5.35c-3.12.87-4.69,1.1-7.41,1.1-3.59,0-6.18-.55-8.61-1.82-4.07-2.16-6.42-5.93-6.42-10.25,0-5.35,3.8-9.91,9.43-11.38,1.36-.35,2.96-.52,4.74-.52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13479"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13481",
    className: "cls-10",
    d: "M140.04,268.75c2.55,0,2.72-.39,2.86-.7.15-.36.44-.64.79-.79-.32-.1-.85-.16-1.71-.16h-4.59v1.65h2.66ZM137.42,278.67c.2.02.51.04,1.01.04h2.96c3.16,0,3.4-.64,3.49-.88.06-.17.15-.32.26-.45-.05,0-.83,0-.83,0-.59,0-1.12-.34-1.37-.87-.14-.31-.3-.64-2.79-.64h-2.73s0,2.75,0,2.79M127.44,285.83c-.83,0-1.51-.67-1.51-1.5v-.55c0-.73.53-1.36,1.26-1.48.37-.07.8-.14.8-3.72v-11.35c0-3.59-.34-3.63-.8-3.7-.74-.1-1.29-.74-1.29-1.49v-.54c0-.83.67-1.51,1.51-1.51h18.93c.83,0,1.51.67,1.51,1.51v5.69c0,.78-.6,1.43-1.36,1.5,0,.02,0,.04,0,.06-.07,1.34-.07,1.84-.07,3.03,0,.88,0,1.89.04,3.14l.03.93c.02.37-.11.74-.35,1.03.05,0,.27-.01.32,0l.7.07c.41.04.78.24,1.03.56.25.32.37.72.32,1.12l-.73,5.9c-.1.75-.73,1.32-1.49,1.32h-18.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13483"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13485",
    className: "cls-10",
    d: "M146.34,258.47h-18.94c-1.66,0-3.01,1.35-3.01,3.01v.54c0,1.29.82,2.41,2,2.83.05.42.09,1.13.09,2.35v11.35c0,1.29-.05,2.01-.11,2.4-1.14.44-1.94,1.55-1.94,2.8v.55c0,1.66,1.35,3.01,3.01,3.01h18.82c1.52,0,2.79-1.13,2.98-2.63l.73-5.9c.1-.8-.13-1.62-.64-2.25-.36-.45-.84-.78-1.37-.96l-.02-.73c-.04-1.22-.04-2.21-.04-3.09s0-1.33.03-2.04c.85-.54,1.42-1.48,1.42-2.55v-5.69c0-1.66-1.35-3.01-3.01-3.01M144.97,268.65h.02M146.34,261.49v5.69h-.66c-.54-1.17-1.49-1.58-3.71-1.58h-6.09v4.66h4.16c2.63,0,3.7-.37,4.23-1.61h.7c-.08,1.37-.08,1.89-.08,3.12,0,.9,0,1.93.04,3.2l.04.93h-.65c-.54-1.17-1.49-1.52-4.16-1.52h-4.24v4.15c-.04,1.44.38,1.69,2.51,1.69h2.96c3,0,4.41-.51,4.9-1.86l.7.07-.73,5.9h-18.82v-.55c1.6-.27,2.05-1.37,2.05-5.21v-11.35c0-3.95-.41-4.95-2.1-5.18v-.54h18.94"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13487"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13489",
    className: "cls-27",
    d: "M142.61,17.69v151.04h3.75s1,3.27,1.64,4.4c2.12-3.5,5.35-4.85,8.43-3.62,4.57,2.25,5.61,8.97,7.98,13.64,1.25,3.12.73,7.48-.66,10.23-1.95,3.39-4.83,5.01-8.02,3.9-1.01-.44-1.92-1.84-2.81-2.69-.03.43-.28,1.43-.19,1.92h-41.13l-4.35-9.53v-18.24h6.59V42.35h-5l-4.33-8.94v-16.91l31.44-13.27.27.38,6.39,14.08ZM52.96,119.78l-4.95-42.02-4.44,42.02h9.39ZM77.42,26.28v11.44h-6.77l15.48,131.02h.85l1.57,4.2c1.87-2.92,4.79-4.59,7.86-3.64,5.24,1.93,6.13,9.78,8.74,14.94.67,3.01.53,6.82-.95,9.31-1.75,2.8-4.15,4.53-6.98,3.79-1.41-.1-2.52-1.18-3.64-2.19-.13.48-.32,1.36-.32,1.36h-36.8l-4.47-9.26v-18.51h6.82l-1.94-17.66h-16.98l-2.09,17.66h3.16l6.46,15.83v11.94H14.04l-4.27-9.25v-18.53h6.73L32.68,37.71h-3.36l-4.24-8.22V10.38h46l6.33,15.89h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13491"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13493",
    className: "cls-2",
    d: "M77.42,26.27v11.44h-6.77l15.47,131.01h.84l1.57,4.2c1.87-2.92,4.79-4.59,7.86-3.63,5.24,1.92,6.14,9.77,8.74,14.94.68,3.01.53,6.83-.95,9.31-1.75,2.8-4.15,4.53-6.98,3.79-1.41-.1-2.53-1.18-3.64-2.19-.13.48-.32,1.36-.32,1.36h-36.8l-4.47-9.26v-18.51h6.81l-1.94-17.66h-16.98l-2.09,17.66h3.15l6.47,15.84v11.94H14.04l-4.27-9.25v-18.53h6.73L32.68,37.72h-3.36l-4.24-8.22V10.39h46l6.33,15.89Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13495"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13497",
    className: "cls-2",
    d: "M52.96,119.77h-9.39l4.44-42.02,4.95,42.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13499"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13501",
    className: "cls-2",
    d: "M142.61,17.69v151.04h3.75s1,3.27,1.64,4.4c2.12-3.5,5.35-4.85,8.43-3.62,4.57,2.25,5.61,8.97,7.98,13.64,1.25,3.12.73,7.48-.66,10.23-1.95,3.39-4.83,5.01-8.02,3.9-1.01-.44-1.92-1.84-2.81-2.69-.03.43-.28,1.43-.19,1.92h-41.13l-4.35-9.53v-18.24h6.59V42.35h-5l-4.33-8.94v-16.91l31.44-13.27.27.38,6.39,14.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13503"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13505",
    className: "cls-17",
    d: "M35.58,122.34h19.78l-9.93-82.57-9.85,82.57ZM69.87,27.56h-8.23l16.82,143.75h6.93l.02,14.77h-31.51v-14.77h7.39l-3.6-30.4h-24.26l-3.66,30.4h9.75v14.77H11.68v-14.77h6.71L35.35,27.56h-8.35v-14.6h42.88v14.6h0ZM148.18,179.02c0-4.36,2.63-7.89,5.86-7.89s5.87,3.53,5.87,7.89-2.62,7.89-5.87,7.89-5.86-3.54-5.86-7.89M88.8,179.02c0-4.36,2.62-7.89,5.87-7.89s5.86,3.53,5.86,7.89-2.62,7.89-5.86,7.89-5.87-3.54-5.87-7.89M135.07,171.31h9.67v14.77h-35.58v-14.77h6.6V32.19h-9.34v-13.53l28.66-12.35v165h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13507"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13509",
    className: "cls-42",
    d: "M159.61,297.88c-.21-.21-.44-.45-.88-.86-.01-.01-.01-.04-.01-.1l.89.96Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13523"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13531"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13533",
    className: "cls-42",
    d: "M158.73,216.79c.24-.22.51-.47.88-.86-.27.3-.62.68-.89.97,0-.05,0-.1.01-.11"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g13535"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13543"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13545",
    className: "cls-18",
    d: "M159.61,215.94l-.89.97c0-.06,0-.1.01-.11l.9-.81s-.02-.04-.02-.05"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g13547"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13549"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13555"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13557",
    className: "cls-42",
    d: "M13,215.94c.2.21.43.46.88.86.01.01.02.05.01.11l-.89-.97Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g13559"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13567"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13569",
    className: "cls-18",
    d: "M12.99,215.99l.89.81s.01.03.01.07l-.89-.93s0,.02-.01.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13571"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13573",
    className: "cls-21",
    d: "M13,215.94l.89.93v.03l-.89-.96h0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g13603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13605"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13611"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13613",
    className: "cls-42",
    d: "M165.7,290.22c.3.33.5.57.9.96-.31-.3-.72-.68-1.03-.98.07,0,.11,0,.13.02"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g13615"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13617"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13623"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13625",
    className: "cls-37",
    d: "M166.6,291.18l-1.03-.98h.04l.98.98"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13627"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13629",
    className: "cls-21",
    d: "M166.59,291.18l-.98-.98s.07.01.08.02l.85.98s.04-.02.04-.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13631"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13633",
    className: "cls-18",
    d: "M166.55,291.19l-.85-.99h0s.83.99.83.99c.01,0,.02,0,.02,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g13635"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13643"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13645",
    className: "cls-42",
    d: "M166.6,222.64c-.22.22-.48.47-.9.96-.02.02-.05.03-.13.02l1.03-.98Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g13647"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13655"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13657",
    className: "cls-18",
    d: "M166.54,222.61l-.83.99s-.06.03-.13.02l1.03-.98s-.03,0-.07-.03"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g13659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13661"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13667"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13669",
    className: "cls-42",
    d: "M6.91,223.6c-.3-.33-.5-.57-.9-.96.31.29.71.68,1.03.98-.07,0-.11,0-.13-.02"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g13671"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13673"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13679"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13681",
    className: "cls-18",
    d: "M6.01,222.64l1.03.98c-.07.01-.11,0-.13-.02l-.84-.99s-.07.03-.07.03"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g13683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13685"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13691"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13693",
    className: "cls-42",
    d: "M6.01,291.18c.22-.22.47-.45.9-.96.02-.02.05-.02.13-.02l-1.03.98Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g13695"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13697"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13703"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13705",
    className: "cls-5",
    d: "M6.07,291.2l.84-.98s.06-.03.13-.02l-1.03.98s.02,0,.07.02"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g13707"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13709",
    className: "cls-12",
    d: "M10.22,212.88l3.67,4.02h144.83l3.68-4.02H10.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13719"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13721",
    className: "cls-48",
    d: "M13.89,216.9h144.84c-.07-.64.94,1.48,3.12,3.59,2.22,2.19,4.44,3.18,3.74,3.13v66.58c.7-.05-1.52.93-3.74,3.11-2.17,2.11-3.19,4.24-3.12,3.6H13.89c.08.64-.93-1.49-3.11-3.6-2.21-2.18-4.45-3.16-3.74-3.11v-66.58c-.71.05,1.53-.94,3.74-3.13,2.18-2.11,3.19-4.23,3.11-3.59"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13723"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13725",
    className: "cls-14",
    d: "M158.72,296.91l3.67,4.03H10.22l3.67-4.03h144.84Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13727"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13729",
    className: "cls-49",
    d: "M7.04,290.2l-4.03,3.83v-74.24l4.03,3.83v66.58Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13731"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13733",
    className: "cls-12",
    d: "M165.57,223.62l4.03-3.83v74.24l-4.03-3.83v-66.58Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13735"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13737",
    className: "cls-42",
    d: "M13.87,297.02q-.52.48-3.66,3.93c-.19-2.04-.8-3.32-2.26-4.75-1.51-1.47-2.85-2.06-4.94-2.17l3-2.85c.22-.21.47-.46.9-.96-.13.14,1.87,1.13,3.86,3.09,1.97,1.92,2.97,3.84,3.1,3.71"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g13739"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13741"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13747"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13749",
    className: "cls-14",
    d: "M13.89,296.91l-3.67,4.03c-.01-.07-.02-.14-.02-.2l3.7-3.78s0-.03,0-.05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13751"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13753",
    className: "cls-41",
    d: "M13.89,296.96l-3.7,3.78c0-.11-.03-.22-.04-.32l3.72-3.4s.02-.02.02-.05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13755"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13757",
    className: "cls-23",
    d: "M13.87,297.02l-3.72,3.4c-.02-.13-.04-.25-.05-.37l3.74-3.03s.03,0,.03,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13759"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13761",
    className: "cls-24",
    d: "M13.84,297.02l-3.74,3.03c-.02-.14-.05-.28-.08-.42l3.75-2.69s.07.06.08.08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13763"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13765",
    className: "cls-53",
    d: "M13.76,296.94l-3.75,2.69c-.04-.15-.08-.3-.13-.44l3.74-2.42c.05.07.09.13.14.18"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13767"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13769",
    className: "cls-38",
    d: "M13.62,296.77l-3.73,2.41c-.06-.16-.1-.32-.16-.48l3.67-2.24c.09.12.16.22.22.31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13771"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13773",
    className: "cls-15",
    d: "M13.4,296.46l-3.67,2.24c-.08-.18-.17-.37-.25-.55l3.56-2.19c.14.19.26.35.36.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13775"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13777",
    className: "cls-44",
    d: "M13.04,295.96l-3.57,2.19c-.12-.24-.27-.48-.43-.71l3.35-2.33c.25.31.47.59.66.85"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13779"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13781",
    className: "cls-16",
    d: "M12.39,295.11l-3.35,2.33c-.29-.42-.65-.83-1.08-1.24-.6-.58-1.17-1.03-1.77-1.37l2.14-3.55c.7.5,1.58,1.18,2.46,2.04.64.62,1.17,1.25,1.61,1.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13783"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13785",
    className: "cls-44",
    d: "M8.32,291.27l-2.14,3.55c-.23-.12-.48-.23-.72-.33l2.14-3.73c.2.15.44.32.72.51"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13787"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13789",
    className: "cls-15",
    d: "M7.6,290.76l-2.14,3.73c-.19-.07-.38-.14-.59-.19l2.32-3.81c.1.07.24.17.41.27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13793",
    className: "cls-38",
    d: "M7.2,290.5l-2.32,3.81c-.17-.05-.33-.09-.52-.13l2.63-3.84s.12.09.21.16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13795"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13797",
    className: "cls-53",
    d: "M6.99,290.33l-2.63,3.84c-.15-.03-.3-.05-.47-.07l3.02-3.87s.03.06.08.09"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13799"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13801",
    className: "cls-24",
    d: "M6.91,290.24l-3.02,3.87c-.14-.03-.27-.04-.42-.06l3.46-3.84s-.03.02-.02.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13803"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13805",
    className: "cls-23",
    d: "M6.93,290.2l-3.46,3.84c-.11,0-.22-.01-.33-.02l3.87-3.83s-.06,0-.08,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13807"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13809",
    className: "cls-41",
    d: "M7,290.2l-3.87,3.83h-.12l4.03-3.83h-.04Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g13811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13819"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13821",
    className: "cls-42",
    d: "M165.7,290.22q.5.57,3.91,3.81c-2.11.11-3.44.7-4.95,2.17-1.46,1.43-2.07,2.71-2.26,4.75l-2.79-3.07c-.31-.33-.47-.49-.84-.82.09.09,1.11-1.83,3.07-3.75,1.99-1.96,3.98-2.94,3.87-3.09"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g13823"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13831"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13833",
    className: "cls-14",
    d: "M165.57,290.2l4.03,3.83h0l-4.03-3.83Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13835"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13837",
    className: "cls-46",
    d: "M165.57,290.2l4.03,3.83c-.05,0-.11,0-.18.01l-3.8-3.84h-.05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13839"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13841",
    className: "cls-51",
    d: "M165.63,290.2l3.81,3.84c-.06,0-.12,0-.19.01l-3.58-3.84s-.02,0-.04,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13843"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13845",
    className: "cls-7",
    d: "M165.66,290.2l3.58,3.84c-.09,0-.18.02-.27.02l-3.26-3.85s-.01-.02-.04-.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13847"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13849",
    className: "cls-39",
    d: "M165.7,290.22l3.26,3.85c-.13.02-.27.04-.41.05l-2.87-3.85s.03-.04.02-.05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13851"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13853",
    className: "cls-47",
    d: "M165.7,290.27l2.86,3.85c-.19.04-.39.08-.58.12l-2.44-3.84c.08-.05.13-.1.15-.14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13855"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13857",
    className: "cls-4",
    d: "M165.54,290.4l2.44,3.84c-.27.07-.53.15-.78.25l-2.15-3.74c.22-.13.38-.25.5-.34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13859"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13861",
    className: "cls-52",
    d: "M165.04,290.75l2.15,3.74c-.9.33-1.69.88-2.53,1.71-.19.18-.36.35-.52.54l-3.07-2.62c.24-.26.49-.54.77-.81,1.23-1.22,2.47-2.06,3.21-2.56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13863"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13865",
    className: "cls-4",
    d: "M161.06,294.12l3.07,2.62c-.19.22-.37.44-.53.67l-3.35-2.35c.24-.3.51-.61.8-.94"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13867"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13869",
    className: "cls-47",
    d: "M160.26,295.06l3.35,2.35c-.12.16-.22.32-.32.5l-3.51-2.22c.15-.2.31-.41.49-.62"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13871"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13873",
    className: "cls-39",
    d: "M159.78,295.68l3.5,2.22c-.08.13-.16.27-.22.42l-3.61-2.2c.11-.13.21-.28.33-.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13875"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13877",
    className: "cls-7",
    d: "M159.45,296.12l3.61,2.2c-.07.11-.12.24-.17.37l-3.67-2.24c.07-.1.14-.21.22-.33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13879"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13881",
    className: "cls-51",
    d: "M159.23,296.45l3.66,2.24c-.03.1-.08.22-.11.34l-3.72-2.37c.04-.06.1-.14.17-.22"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13883"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13885",
    className: "cls-46",
    d: "M159.06,296.68l3.72,2.36c-.03.1-.07.21-.1.32l-3.73-2.51s.06-.1.11-.16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13887"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13889",
    className: "cls-14",
    d: "M158.94,296.84l3.74,2.51c-.03.08-.05.18-.08.27l-3.75-2.68s.05-.07.09-.1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13891"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13893",
    className: "cls-41",
    d: "M158.85,296.94l3.75,2.68c-.02.08-.04.18-.06.27l-3.74-2.9s.04-.04.05-.05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13895"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13897",
    className: "cls-23",
    d: "M158.8,297l3.74,2.89c-.01.08-.02.16-.04.24l-3.74-3.1s.02-.01.04-.03"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13899"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13901",
    className: "cls-24",
    d: "M158.76,297.02l3.74,3.11c-.02.07-.03.14-.03.22l-3.74-3.33s.01,0,.03,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13903"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13905",
    className: "cls-53",
    d: "M158.73,297.02l3.74,3.33c-.02.07-.03.14-.03.2l-3.72-3.55v.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13907"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13909",
    className: "cls-38",
    d: "M158.72,297l3.72,3.55c-.01.06-.02.11-.03.17l-3.7-3.75s0,.03,0,.03"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13911"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13913",
    className: "cls-15",
    d: "M158.72,296.97l3.7,3.76s0,.1-.03.15l-3.67-3.94s0,.03,0,.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13915"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13917",
    className: "cls-44",
    d: "M158.72,296.93l3.67,3.94v.07l-3.67-4.03v.02Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g13919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13927"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13929",
    className: "cls-42",
    d: "M158.73,216.79q.53-.48,3.66-3.91c.19,2.04.8,3.31,2.26,4.75,1.51,1.47,2.84,2.06,4.95,2.16l-3,2.85c-.24.23-.48.47-.9.96.11-.14-1.88-1.13-3.87-3.1-1.95-1.91-2.97-3.82-3.1-3.7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g13931"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13933"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13939"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13941",
    className: "cls-11",
    d: "M158.72,216.9l3.67-4.03s0,.09.02.13l-3.7,3.87s0,.02,0,.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13943"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13945",
    className: "cls-43",
    d: "M158.72,216.86l3.69-3.87c0,.06,0,.13.02.19l-3.71,3.64s0,.03,0,.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13947"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13949",
    className: "cls-13",
    d: "M158.72,216.82l3.71-3.63c.01.08.01.16.04.25l-3.74,3.36s-.01.01-.01.03"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13951"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13953",
    className: "cls-25",
    d: "M158.73,216.79l3.74-3.36c0,.1.02.2.03.31l-3.74,3.05s-.02,0-.03,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13955"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13957",
    className: "cls-40",
    d: "M158.76,216.79l3.75-3.05c.02.13.05.25.07.38l-3.74,2.73s-.05-.05-.08-.07"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13959"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13961",
    className: "cls-54",
    d: "M158.84,216.85l3.75-2.73c.04.14.08.3.12.44l-3.74,2.45c-.05-.07-.1-.13-.13-.16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13963"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13965",
    className: "cls-22",
    d: "M158.97,217.02l3.74-2.46c.04.18.11.36.17.54l-3.67,2.25c-.1-.13-.17-.24-.24-.33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13967"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13969",
    className: "cls-6",
    d: "M159.21,217.35l3.67-2.25c.09.23.2.45.32.67l-3.54,2.21c-.18-.24-.33-.45-.45-.62"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13971"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13973",
    className: "cls-8",
    d: "M159.66,217.97l3.54-2.21c.23.44.53.84.9,1.26l-3.1,2.6c-.54-.61-.99-1.19-1.34-1.66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13975"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13977",
    className: "cls-26",
    d: "M161,219.63l3.1-2.6c.17.19.36.39.55.6.15.14.3.28.46.42l-2.61,3.08c-.22-.19-.44-.41-.67-.63-.3-.28-.59-.59-.83-.87"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13979"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13981",
    className: "cls-8",
    d: "M162.51,221.13l2.61-3.08c.43.37.86.68,1.3.93l-2.13,3.56c-.52-.37-1.13-.83-1.77-1.41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13983"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13985",
    className: "cls-6",
    d: "M164.28,222.53l2.13-3.56c.23.13.47.23.7.33l-2.12,3.72c-.2-.14-.44-.3-.71-.49"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13987"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13989",
    className: "cls-22",
    d: "M164.98,223.02l2.12-3.72c.17.07.36.14.54.19l-2.27,3.81c-.11-.08-.25-.17-.4-.27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13991"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13993",
    className: "cls-54",
    d: "M165.39,223.29l2.27-3.81c.16.05.31.09.47.11l-2.53,3.84c-.05-.04-.13-.09-.2-.15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13995"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13997",
    className: "cls-40",
    d: "M165.59,223.45l2.53-3.84c.12.03.25.05.39.08l-2.83,3.85s-.05-.04-.09-.09"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14001",
    className: "cls-25",
    d: "M165.68,223.53l2.83-3.85c.1.02.21.03.32.04l-3.13,3.86s0-.03-.02-.05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14003"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14005",
    className: "cls-13",
    d: "M165.7,223.59l3.13-3.86c.09.01.18.02.27.03l-3.42,3.85s.02-.01.02-.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14007"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14009",
    className: "cls-43",
    d: "M165.69,223.6l3.42-3.85c.06.01.14.02.21.02l-3.68,3.85s.04-.01.04-.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14011"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14013",
    className: "cls-11",
    d: "M165.64,223.62l3.68-3.84c.05,0,.11.01.16.01l-3.88,3.83h.03"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14015"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14017",
    className: "cls-19",
    d: "M165.61,223.62l3.88-3.83h.11l-4.03,3.83h.04Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g14019"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14027"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14029",
    className: "cls-42",
    d: "M6.91,223.6q-.5-.57-3.9-3.81c2.1-.1,3.44-.7,4.94-2.16,1.46-1.43,2.07-2.71,2.26-4.75l2.78,3.06c.33.34.47.49.84.82-.09-.08-1.1,1.83-3.06,3.74-1.99,1.97-3.99,2.96-3.87,3.1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g14031"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14033"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14039"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14041",
    className: "cls-16",
    d: "M7.04,223.62l-4.03-3.83h.07l3.95,3.83h.01Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14043"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14045",
    className: "cls-44",
    d: "M7.03,223.62l-3.95-3.83s.1,0,.14,0l3.76,3.84h.05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14047"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14049",
    className: "cls-15",
    d: "M6.98,223.62l-3.76-3.84c.06,0,.11,0,.17-.01l3.55,3.85h.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14051"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14053",
    className: "cls-38",
    d: "M6.94,223.62l-3.55-3.85c.07,0,.12-.02.19-.02l3.35,3.85s.01.01.02.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14055"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14057",
    className: "cls-53",
    d: "M6.92,223.6l-3.35-3.86c.08,0,.14-.01.22-.02l3.12,3.87.02.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14059"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14061",
    className: "cls-24",
    d: "M6.91,223.59l-3.12-3.87c.08,0,.15-.02.24-.03l2.9,3.86s-.02.03-.02.03"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14063"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14065",
    className: "cls-23",
    d: "M6.92,223.55l-2.9-3.85c.09-.02.17-.03.26-.05l2.68,3.85s-.04.04-.04.05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14067"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14069",
    className: "cls-41",
    d: "M6.96,223.5l-2.68-3.85c.09-.01.19-.03.27-.05l2.49,3.84s-.06.05-.09.07"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14071"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14073",
    className: "cls-14",
    d: "M7.05,223.43l-2.49-3.84c.1-.03.2-.05.31-.08l2.32,3.81c-.05.04-.1.07-.14.1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14075"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14077",
    className: "cls-46",
    d: "M7.19,223.33l-2.32-3.82c.1-.03.21-.06.32-.1l2.2,3.78c-.07.05-.14.09-.19.14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14079"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14081",
    className: "cls-51",
    d: "M7.38,223.19l-2.2-3.77c.11-.03.22-.08.33-.12l2.12,3.72c-.09.07-.18.12-.26.18"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14083"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14085",
    className: "cls-7",
    d: "M7.64,223.02l-2.12-3.71c.12-.05.24-.1.35-.16l2.11,3.65c-.11.08-.23.15-.33.22"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14087"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14089",
    className: "cls-39",
    d: "M7.97,222.79l-2.11-3.64c.12-.06.25-.13.37-.19l2.14,3.55c-.13.1-.27.2-.4.28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14091"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14093",
    className: "cls-47",
    d: "M8.38,222.5l-2.14-3.55c.14-.08.27-.16.41-.26l2.24,3.42c-.18.14-.36.27-.52.38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14095"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14097",
    className: "cls-4",
    d: "M8.9,222.11l-2.24-3.42c.16-.1.32-.22.48-.34l2.43,3.24c-.22.19-.45.37-.67.53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14099"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14101",
    className: "cls-52",
    d: "M9.56,221.59l-2.43-3.24c.2-.16.4-.33.61-.53l2.72,2.98c-.3.28-.6.54-.9.78"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14105",
    className: "cls-45",
    d: "M10.46,220.8l-2.72-2.98c.07-.07.14-.13.21-.2.28-.28.54-.56.76-.83l3.2,2.49c-.33.39-.72.8-1.14,1.22-.1.1-.21.2-.32.31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14109",
    className: "cls-20",
    d: "M11.92,219.28l-3.2-2.49c.35-.43.62-.85.83-1.3l3.62,2.18c-.31.44-.73,1-1.25,1.61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14113",
    className: "cls-45",
    d: "M13.17,217.68l-3.61-2.19c.17-.36.31-.73.41-1.12l3.75,2.56c-.11.15-.31.41-.55.74"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14115"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14117",
    className: "cls-52",
    d: "M13.71,216.93l-3.75-2.56c.06-.21.1-.42.14-.64l3.75,3.07s-.08.06-.14.14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14121",
    className: "cls-4",
    d: "M13.85,216.79l-3.75-3.06c.03-.13.04-.26.06-.39l3.72,3.47s-.01-.02-.03-.01"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14125",
    className: "cls-47",
    d: "M13.89,216.8l-3.72-3.47c0-.08.02-.17.03-.26l3.7,3.77s0-.03,0-.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14129",
    className: "cls-39",
    d: "M13.89,216.85l-3.7-3.77c.01-.07.01-.13.02-.2l3.67,4.02v-.05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14133",
    className: "cls-7",
    d: "M13.89,216.9l-3.67-4.02h0s3.67,4.02,3.67,4.02h0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g14143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14145",
    className: "cls-10",
    d: "M42.62,234.34h-.74c-1.36-1.54-3.46-2.4-5.92-2.4-2.18,0-3.62.96-3.62,2.37,0,.86.66,1.55,2.14,2.2.38.17,1.45.61,3.13,1.33,4.6,1.93,6.34,3.85,6.34,7.07,0,4.35-4,7.13-10.17,7.13-2.35,0-4.4-.32-7.36-1.13l-.62-5.22.62-.07c1.56,1.68,3.78,2.5,6.7,2.5s4.77-1.17,4.77-2.91c0-1.27-.9-2.14-3.41-3.15-5.31-2.16-6.79-3.13-7.78-5.18-.34-.7-.49-1.45-.49-2.23,0-3.92,3.62-6.59,8.89-6.59,1.45,0,2.88.18,4.7.58.49.11.99.18,1.24.18s.49-.04.86-.18h.74v5.69Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14149",
    className: "cls-10",
    d: "M58.99,245.74c0,3.81.49,4.98,2.22,5.21v.55c-2.46-.03-3.45-.07-5.43-.07s-2.87.04-5.27.07v-.55c1.64-.24,2.09-1.3,2.09-5.21v-12.9h-1.73c-3.09,0-4.24.34-4.85,1.47h-.66l.66-5.66h19.67l.66,5.66h-.66c-.61-1.13-1.77-1.47-4.86-1.47h-1.85v12.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14153",
    className: "cls-10",
    d: "M78.54,237.44h4.16c2.63,0,3.7-.38,4.24-1.62h.71c-.09,1.37-.09,1.89-.09,3.12,0,.89,0,1.92.05,3.2l.04.92h-.66c-.54-1.17-1.48-1.51-4.16-1.51h-4.24v4.15c-.04,1.44.36,1.68,2.51,1.68h2.96c3,0,4.4-.51,4.89-1.85l.7.07-.74,5.9h-18.81v-.55c1.61-.27,2.06-1.37,2.06-5.21v-11.35c0-3.95-.42-4.94-2.09-5.18v-.55h18.93v5.69h-.66c-.55-1.16-1.48-1.57-3.71-1.57h-6.09v4.66Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14157",
    className: "cls-10",
    d: "M109.78,247.18l.91,1.71c.03.1.12.31.24.61.08.25.12.42.12.56,0,.48-.36.79-1.06.89v.55l1.97-.03c1.32,0,2.47-.03,3.46-.03,1.48,0,2.14.03,3.91.06v-.55c-.74-.45-1.32-1.13-2.06-2.53l-11.6-21.02h-.84l-11.93,21.02c-.95,1.72-1.31,2.16-1.98,2.53v.55c1.4-.03,1.9-.06,3.21-.06.95,0,2.1.03,3.46.03l2.02.03v-.55c-.71-.16-.99-.45-.99-.93,0-.2.08-.44.28-.82l1.11-2.02h9.76ZM108.27,243.23h-6.55l3.2-6.75,3.35,6.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14161",
    className: "cls-10",
    d: "M144.89,248.96c1.24,1.3,1.82,1.75,2.76,1.99v.54l-.99.04-2.05.1c-.42.03-.83.07-1.28.07-3.26,0-4.42-.38-5.73-1.89l-8.45-9.47v5.39c0,3.84.46,4.97,2.15,5.21v.54c-2.6-.03-3.66-.06-5.52-.06-1.77.03-2.76.03-5.09.06v-.54c1.63-.24,2.05-1.27,2.05-5.21v-11.32c0-3.94-.42-4.98-2.05-5.22v-.55h2.05c1.4.03,2.42.03,3.16.03.7,0,1.77,0,3.21-.03h2.18v.55c-1.69.24-2.15,1.37-2.15,5.22v3.84l7.17-6.9c.83-.79,1.03-1.06,1.03-1.45,0-.41-.37-.65-1.03-.72v-.55h1.61l3.62.03,3.58-.03h1.89v.55c-1.28.27-2.27.89-3.87,2.4l-7.74,7.2,9.47,10.16Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14163"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14165",
    className: "cls-10",
    d: "M41.04,267.18h-.74c-1.35-1.54-3.45-2.4-5.93-2.4-2.18,0-3.61.96-3.61,2.36,0,.87.66,1.55,2.14,2.2.37.17,1.44.61,3.13,1.34,4.62,1.93,6.34,3.84,6.34,7.07,0,4.36-3.99,7.14-10.17,7.14-2.35,0-4.4-.31-7.36-1.13l-.62-5.22.62-.07c1.56,1.68,3.78,2.5,6.7,2.5s4.78-1.17,4.78-2.92c0-1.26-.91-2.12-3.42-3.15-5.31-2.16-6.79-3.13-7.77-5.18-.33-.68-.5-1.45-.5-2.23,0-3.91,3.62-6.59,8.89-6.59,1.44,0,2.88.18,4.7.59.49.1.99.17,1.24.17s.48-.03.85-.17h.74v5.69Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14169",
    className: "cls-10",
    d: "M61.67,280l.91,1.72c.04.1.11.3.24.62.09.24.13.41.13.54,0,.48-.37.78-1.07.89v.55l1.98-.03c1.32,0,2.47-.03,3.45-.03,1.48,0,2.14.03,3.91.07v-.55c-.74-.44-1.31-1.13-2.05-2.53l-11.61-21.03h-.83l-11.94,21.03c-.94,1.72-1.31,2.16-1.97,2.53v.55c1.39-.03,1.89-.07,3.2-.07.95,0,2.1.03,3.46.03l2.01.03v-.55c-.7-.17-.98-.44-.98-.93,0-.21.07-.45.28-.83l1.12-2.02h9.75ZM60.14,276.06h-6.54l3.21-6.76,3.33,6.76Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14173",
    className: "cls-10",
    d: "M70.1,261.48h2.06l3.09.04,3.3-.04h2.06v.54c-1.62.24-2.06,1.3-2.06,5.22v7.07c0,2.75.32,4.08,1.19,4.97.87.9,2.38,1.41,4.12,1.41,2.1,0,3.91-.79,4.65-1.99.65-1.03.73-1.68.73-4.84v-6.62c0-3.95-.4-4.98-2.02-5.22v-.54h2.02l3.22.04,3.26-.04h2.05v.54c-1.65.21-2.14,1.34-2.14,5.22v6.89c0,4.46-.33,5.76-2.06,7.48-2.18,2.19-5.56,3.26-9.96,3.26-7.2,0-11.45-3.19-11.45-8.64v-8.98c0-3.88-.45-5.01-2.06-5.22v-.54Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14177",
    className: "cls-10",
    d: "M123.74,267.18h-.57c-1.94-1.37-4.12-2.06-6.84-2.06-5.22,0-8.8,3.15-8.8,7.76s3.58,7.82,8.8,7.82c2.75,0,5.27-.82,7.08-2.37l.67.1-.67,5.34c-3.12.87-4.69,1.11-7.41,1.11-3.58,0-6.18-.55-8.6-1.82-4.08-2.16-6.42-5.93-6.42-10.25,0-5.35,3.8-9.91,9.43-11.38,1.36-.34,2.96-.52,4.74-.52,1.93,0,3.45.18,5.59.65.59.13,1.08.21,1.49.21.28,0,.45-.08.74-.27h.78v5.69Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14181",
    className: "cls-10",
    d: "M135.88,270.26h4.16c2.63,0,3.7-.38,4.23-1.61h.7c-.08,1.37-.08,1.89-.08,3.12,0,.9,0,1.93.04,3.2l.03.93h-.65c-.54-1.17-1.49-1.51-4.16-1.51h-4.24v4.15c-.04,1.44.38,1.69,2.51,1.69h2.96c2.99,0,4.4-.51,4.89-1.86l.7.07-.73,5.9h-18.82v-.55c1.6-.27,2.05-1.37,2.05-5.21v-11.35c0-3.95-.41-4.94-2.1-5.18v-.54h18.94v5.69h-.66c-.54-1.17-1.49-1.58-3.71-1.58h-6.09v4.66Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA1);
export default __webpack_public_path__ + "static/media/a1.add0379b40c66a94b3e5504e2d31ccaa.svg";
export { ForwardRef as ReactComponent };